//=============================================================================
// Contents   : HRDB
//              従業員詳細
//              GetInformationDetail
// Author     : RV光永
// LastUpdate : 2023/01/05
// Since      : 2022/12/2
//=============================================================================

/* ======================================================================================================================================================= */
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  
/* ====== React ====== */
import React, { useEffect, useState } from "react";
import { useForm ,useFieldArray} from "react-hook-form";
import { useNavigate,useLocation } from 'react-router-dom';
import { useProvideData } from "03CommonApiParts/use-context";

/* ====== CSS ====== */
// import styled from "styled-components";
/* ====== Image ====== */
/* ====== Component Js/Jsx ====== */
import { Underbar } from "02CommonUiParts/OtherParts/Underbar";
import { LeftTitleTable } from "02CommonUiParts/TableParts/LeftTitleTable";
import { SnackBar } from "02CommonUiParts/MessageParts/SnackBar";
import { Dialog } from "02CommonUiParts/MessageParts/Dialog";
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { Title } from "01Pages/Common/UiParts/Title";
import { ButtonApplydayReturn} from "02CommonUiParts/ButtonParts/ButtonBase";
import { CFArrayDuplicateCheck, CFArrayFount, CFCheckArrayData, CFCreateApplyList, CFDateFormatEdit, CFJsonIgnore, CFStringDecodeJP, CFStringEncodeJP, CFUTCToDateInputFormatEdit, checkChangeFlag, confirmChange } from "03CommonApiParts/CommonFunction";
import { TableArray } from '02CommonUiParts/TableParts/TableArray';
import { ButtonHistory } from "02CommonUiParts/ButtonParts/ButtonBase";
/* ====== Style ====== */
import { StyleCommon } from "01Pages/Common/Style/StyleCommon";
import { StyleEmployee } from "01Pages/Employee/Information/StyleEmployee";
import { CODEDIFINITION_STORAGE, patternCheckMaster, screenMaster, USERINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { Table } from "02CommonUiParts/TableParts/Table";
import { screenDisplayMessage } from "03CommonApiParts/MessageList";


/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */ 

/* ======================================================================== */
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  
/* ベース64スイッチ */
const base64Swicth = true;	//エンコード処理スイッチ
/* スタイル */
const CommonStyle =  StyleCommon();//共通スタイルドコンポーネント
const EmployeeStyle =  StyleEmployee();//従業員スタイルドコンポーネント

/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */ 

/* ========= 従業員詳細 ========= */
export const GetInformationDetail = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    const navigate = useNavigate();//画面遷移用
    const apiData = useProvideData();//APIデータ取得
    const location = useLocation();//遷移元データ取得用
    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== hookformを定義 ====== */ 
    const { register, handleSubmit, getValues, setValue, watch, reset, clearErrors,control, formState: { errors } } = useForm({//setValue, onChange
		mode: 'onBlur',
		reValidateMode: 'onChange',
		shouldUseNativeValidation: false,
		shouldUnregister: false,
	});
    /* ====== useFieldArrayを定義 ====== */ 
    const { fields:CncDptListFields, append:Append, remove:Remove,update: Update } = useFieldArray(
        {
            control,
            name: "payload.cncDptList"
        }
    );
    const fieldsArray = {
        cncDptList:{
            fields:CncDptListFields, 
            append:Append, 
            remove:Remove,
            update:Update
        }
    }
    const { fields:MoveInFields, append:MoveInAppend, remove:MoveInRemove ,update:MoveInUpdate} = useFieldArray(
        {
            control,
            name: "payload.movein"
        }
    );
    const { fields:MoveOutFields, append:MoveOutAppend, remove:MoveOutRemove ,update:MoveOutUpdate} = useFieldArray(
        {
            control,
            name: "payload.moveout"
        }
    );
    const { fields:AbsenceFields, append:AbsenceAppend, remove:AbsenceRemove ,update:AbsenceUpdate} = useFieldArray(
        {
            control,
            name: "payload.absence"
        }
    );

    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */
    const [progress, setProgress] = useState(false); //プログレスバー表示用
    const [dialogMessage, setDialogMessage] = useState({ //ダイアログ表示用
        open:false,
    });
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    const [pageMode, setPageMode] = useState(); //画面モード
    const [loading, setLoading] = useState(false); //画面表示用

    const [dataRow, setDataRow] = useState(); //データ送り用
    const [confirm, setConfirm] = useState({});//確認用データ格納用
    const [newData, setNewData] = useState();//変更後データ格納用
    const [master, setMaster] = useState();//マスタデータ格納用
    const [disableItem, setDisableItem] = useState();//disableデータ格納用
    
    const [buttonState, setButtonState] = useState(); //編集ボタンを管理
    const [copyButtonState, setCopyButtonState] = useState({base:false,dpt:false,temporary:false,assigned:false,accepted:false,contract:false});
    const [deleteButtonState, setdeleteButtonState] = useState({base:false,dpt:false,temporary:false,assigned:false,accepted:false,contract:false});
    const [editButtonState, setEditButtonState] = useState({base:false,dpt:false,temporary:false,assigned:false,accepted:false,contract:false});

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */
    const keyList = {
        //基本情報
        base:'aplySrtDate',
        //所属部署情報
        dpt:'afiDptAplySrtDate',
        //エキスパート情報
        expert:'exptAplySrtDate',
        //派遣社員情報
        temporary:'tmpCntrTermSrtDate',
        //契約社員情報
        contract:'cntrTermSrtDate',
        //出向(受)社員情報
        accepted:'secAcpCntrTermSrtDate',
        //出向(出)社員情報
        assigned:'crntSecTermSrtDate',
        //休務/休職情報
        absence:'absenceTermSrtDate',
        //転入情報
        movein:'moveInDate',				
        //転出情報
        moveout:'moveOutDate'
    };
    const applyList = {
        base:'applyList',
        dpt:'dptApplyList',        
        expert:'expertApplyList',
        temporary:'temporaryApplyList',
        assigned:'assignedApplyList',
        accepted:'acceptedApplyList',
        contract:'contractAppyList'
    };
    /* ====== sessionStorageからの情報を定義 ====== */
    /* USERINFO_STORAGEから従業員情報を取得 */
    const userInfoStorage = sessionStorage.getItem(USERINFO_STORAGE);
    var userInfoValue = JSON.parse(userInfoStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    const userName = userInfoValue.empJpnSrname + ' ' + userInfoValue.empJpnName;//名前
    const screenId = CFArrayFount(screenMaster,'path',location.pathname).id;//画面Id
   /* CODEDIFINITION_STORAGEからコード定義を取得 */
	const codeDefinitionStorage = sessionStorage.getItem(CODEDIFINITION_STORAGE);//sessionStorageからコードマスタを取得
	var codeDefinitionValue = JSON.parse(codeDefinitionStorage);//JSON 文字列を取得し、JavaScriptオブジェクトに変換

    /* ====== localStorageからの情報を定義 ====== */ 
    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 
    // var passValue = JSON.parse(storageToken);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    /* ====== コードマスタから必要なデータの抽出 ====== */ 

    /* ---------------------------------------------------- */
    /* -------------------- Master ------------------------ */
    /* ---------------------------------------------------- */
	const genderCode = CFArrayFount(codeDefinitionValue,'code','genderCode');//性別コード
	const leaveOfAbsenceCode = CFArrayFount(codeDefinitionValue,'code','leaveOfAbsenceCode');//休務/休職コード
	const employmentTermDisitionFlag = CFArrayFount(codeDefinitionValue,'code','employmentTermDisitionFlag');//雇用期間の定めフラグ
	const introductionScheduleTemporaryFlag = CFArrayFount(codeDefinitionValue,'code','introductionScheduleTemporaryFlag');//紹介予定派遣フラグ
	const flexApplyFlag = CFArrayFount(codeDefinitionValue,'code','flexApplyFlag');//フレックス適用フラグ
	const salaryBaseCode = CFArrayFount(codeDefinitionValue,'code','salaryBaseCode');//給与基準コード
	const travelExpensesCode = CFArrayFount(codeDefinitionValue,'code','travelExpensesCode');//旅費基準コード
	const contractFormatCode = CFArrayFount(codeDefinitionValue,'code','contractFormatCode');//契約書フォーマットコード
	const salaryFormCode = CFArrayFount(codeDefinitionValue,'code','salaryFormCode');//給与形態コード
	const occupationCode = CFArrayFount(codeDefinitionValue,'code','occupationCode');//職種コード
	const departmentMaster = master? master.departmentMaster : [];//部署マスタ
	const postMaster = master? master.postMaster : [];//役職マスタ
	const employmentStatusMaster = master? master.employmentStatusMaster : [];//雇用形態マスタ
	const placeToWorkMaster = master? master.placeToWorkMaster : [];//勤務地マスタ
	const rankMaster = master? master.rankMaster : [];//ランクマスタ
	const groupradeMaster = master ? master.gradeMaster : [];//等級マスタ
	const clientMaster = master? master.clientMaster : [];//取引先マスタ
	const supplierMaster = master? master.supplierMaster : [];//仕入先マスタ

    /* ---------------------------------------------------- */
    /* ----------------- 　取得API項目　 -------------------- */
    /* ---------------------------------------------------- */
	const apiItem = {
		/* 基本情報の項目 */
		base:[
			{name:'otpDate',             		base64:false,type:'date'},  //出力日
			{name:'aplySrtDate',            	base64:false, type:'date' },  //適用日
			{name:'empNmb',                 	base64:false },  //従業員番号						
			{name:'empJpnSrname',	        	base64:true },  //従業員日本語姓						
			{name:'empJpnName',	            	base64:true },  //従業員日本語名						
			{name:'empJpnMidName',          	base64:true },  //従業員日本語ミドルネーム
			{name:'empFrgnSrname',          	base64:true },  //従業員フリガナ姓						
			{name:'empFrgnName',	        	base64:true },  //従業員フリガナ名
			{name:'empFrgnMidName',         	base64:true },  //従業員フリガナミドルネーム						
			{name:'empEngSrname',	        	base64:false },  //従業員英語姓						
			{name:'empEngName',	            	base64:false },  //従業員英語名
			{name:'empEngMidName',          	base64:false },  //従業員英語ミドルネーム
			{name:'empAbrName',	            	base64:true },  //従業員略名
			{name:'empFmlyName',            	base64:true },  //従業員戸籍名						
			{name:'gendCd',			        	base64:false },  //性別コード					
			{name:'bday',				    	base64:false,type:'date' },  //生年月日						
			{name:'empiSttsCd',			    	base64:false },  //雇用形態コード						
			{name:'entryDate',					base64:false, type:'date' },  //入社日						
			{name:'plgePresnDate',				base64:false, type:'date'},  //誓約書提出日						
			{name:'workLocoCd',					base64:false },  //勤務地コード						
			{name:'workLocoAdres',				base64:true },	//勤務地住所						
			{name:'rkCd',				    	base64:false },  //ランクコード
			{name:'hrAprvNmb',					base64:false },  //人事稟議番号						
			{name:'aprvOrgTimeCst',				base64:false },	//稟議起案時費用
			{name:'lastToWorkDate',				base64:false, type:'date' },	//最終出社日						
			{name:'rtiDate',					base64:false, type:'date'},  //退職日						
			{name:'cmntField',					base64:true } //コメント欄
		],
    		/* 所属部署情報の項目 */
		dpt:[					
			{name:'afiDptAplySrtDate',	        base64:false, type:'date' },  //適用日	
			{name:'dptCd',	name2:'dptName',    base64:false, base642:true},  //部署コード 部署名
            {name:'lboCstClasfName',			base64:true },	//人件費区分名			
			{name:'postCd',			        	base64:false },  //役職コード
			{name:'cncDptList',					base64:false },	//兼務部署リスト											
		],    
		/* エキスパートの項目 */
		expert:[
			{name:'exptAplySrtDate',   	base64:false,type:'date'},//適用開始日
			{name:'gradeCd',       		base64:false},//等級コード
			{name:'mnaSpvrFlag',	 	type:Boolean, base64:false}//管理監督者フラグ
		],
		/* 派遣の項目 */
		temporary:[
			{name:'tmpAgnCmpCd', name2:'tmpAgnCmpName',	base64:false, base642:true},//派遣元会社コード 派遣元会社名
			{name:'empiTermDciFlag',	                base64:false},//雇用期間の定めフラグ										
			{name:'itrSchedTmpFlag',	                base64:false},//紹介予定派遣フラグ										
			{name:'tmpCntrTermSrtDate',	                base64:false,type:'date'},//契約開始日									
			{name:'tmpCntrTermExpiDate',	            base64:false,type:'date'},//契約満了予定日										
			{name:'idiCntDate',	                    	base64:false,type:'date'},//個人抵触日
			{name:'tmpFirstRspPsnEmpNmb', 	name2:'tmpFirstRspEmpFullName',		base64:false, base642:true},//派遣先責任者従業員番号	派遣先責任者氏名
			{name:'ledrEmpNmb',             name2:'ledrFullName',	            base64:false, base642:true},//指揮命令者従業員番号	指揮命令者氏名
			{name:'hurRate',	                        base64:false},//時間単価										
			{name:'frsFirstHurRate',	                base64:false},//初回時間単価										
			{name:'uitCstRema',	                    	base64:true},//単価備考										
			{name:'flexAplyFlag',	                    base64:false},//フレックス適用フラグ
			{name:'tmpBsiContField',	                base64:true},//業務内容欄										
			{name:'tmpBsiContDta',	                   	base64:true},//業務内容詳細
			{name:'tmpInfoRema',	               		base64:true},//派遣社員情報備考
			{name:'cntrNtTgtFlag',	               		type:Boolean, base64:false},//契約書対象外フラグ
			{name:'webAttdNtTgtFlag',	                type:Boolean, base64:false},//WEB勤怠対象外フラグ
            {name:'cntrCntFlag',	        			type:Boolean, base64:false}//契約継続フラグ
		],
		/* 契約社員の項目 */		
		contract:[
			{name:'slaFormCd',	            			base64:false},//給与形態コード
			{name:'ocuCd',	                			base64:false},//職種コード
			{name:'distMerh',	        			    base64:true},//配布方法
			{name:'cntrBsiContField',	        	    base64:true},//業務内容欄
			{name:'mergePrintSprt',	        			base64:true},//差し込み印刷対応
			{name:'cntrSrtDate',	        			base64:false,type:'date'},//契約開始日		
			{name:'lngEmpiTerm',	        			base64:false,type:'date'},//最長雇用期間			
			{name:'upIte',	                			base64:false},//更新間隔	
			{name:'cntrTermSrtDate',	    			base64:false,type:'date'},//契約期間開始日
			{name:'cntrTermExpiDate',				    base64:false,type:'date'},//契約期間満了予定日
			{name:'cntrInfoRema',	    			    base64:true},//契約社員情報備考
			{name:'gradeCd',	            			base64:false},//等級コード
			{name:'mnaSpvrFlag',	        			type:Boolean, base64:false},//管理監督者フラグ
			{name:'cntrCntFlag',	        			base64:false}//契約継続フラグ
		],
		/* 出向(受)の項目 */		
		accepted:[
			{name:'secFrmCmpCd',name2:'secFrmCmpName',   base64:false, base642:true},//出向元会社コード,出向元会社名
			{name:'slaBaseCd',	            			base64:false},//給与基準コード	
			{name:'bsiTripExpeStndCd',	    			base64:false},//旅費基準コード	
			{name:'cntrFrmtCd',	            			base64:false},//契約書フォーマットコード
			{name:'secAcpFirstCntrSrtDate',	        	base64:false,type:'date'},//初回契約開始日			
			{name:'secAcpCntrTermSrtDate',	    		base64:false,type:'date'},//現契約期間開始日
			{name:'secAcpCntrTermExpiDate',				base64:false,type:'date'},//現契約満了予定日								
			{name:'secAcpInfoRema',	    			    base64:true},//出向(受)社員情報備考								
			{name:'mnaSpvrFlag',	        			type:Boolean,base64:false},//管理監督者フラグ
            {name:'cntrCntFlag',	        			base64:false}//契約継続フラグ
		],
		/* 出向(出)の項目 */
		assigned:[
			{name:'secSrtDate',	           				base64:false,type:'date'},//出向開始日
			{name:'rtnDate',	           				base64:false,type:'date'},//帰任日										
			{name:'secDestnCmpCd',name2:'secDestnCmpName',base64:false,base642:true},//出向先会社コード 出向先会社名					
			{name:'dptName',	           				base64:true},//部署名
			{name:'secDestnDpt',	       				base64:true},//出向先部署名										
			{name:'cstBrd',	               				base64:false},//費用負担
			{name:'bfSecAfiDptCd',	name2:'bfSecAfiDptName', base64:false,base642:true},//出向前所属部署コード 出向前所属部署名 	
			{name:'secAsiInfoRema',	   				    base64:true},//出向(出)社員情報備考
			{name:'crntSecTermSrtDate',	   				base64:false,type:'date'},//現出向期間開始日
			{name:'crntSecTermEndDate',	   				base64:false,type:'date'},//現出向期間終了日
            {name:'cntrCntFlag',	        			base64:false}//契約継続フラグ
		],
		absence:[
			{name:'absenceTermSrtDate',					base64:false,type:'date'},//休職期間開始日
			{name:'absenceTermEndDate',					base64:false,type:'date'},//休職期間終了日
			{name:'loaClasfCd',							base64:false},//休務/休職区分コード
			{name:'lastUdr',							base64:true},//最終更新者
			{name:'lastUpDate',							base64:false}//最終更新日時
		],
		movein:[
			{name:'moveInDate',							base64:false, type:'date'},//転入日
			{name:'moveInRemaField',					base64:true},//転入備考欄
			{name:'lastUdr',							base64:true},//最終更新者
			{name:'lastUpDate',							base64:false}//最終更新日時
		],
		moveout:[
			{name:'moveOutDate',						base64:false, type:'date'},//転出日
			{name:'moveOutRemaField',					base64:true},//転出備考欄
			{name:'lastUdr',							base64:true},//最終更新者
			{name:'lastUpDate',							base64:false}//最終更新日時
		],
		cncDptList:[
			{name: 'cncDptCd',	name2:'cncDptName', 	base64:false, base642:true},//兼務部署コード 兼務部署名
			{name: 'cncPostCd',							base64:false},//兼務役職コード
		]
	};

    /* ---------------------------------------------------- */
    /* ----------------- 　更新API項目　 -------------------- */
    /* ---------------------------------------------------- */
	const updateApiItem = {
		base:[
            {name:'aplySrtDate',					    type:String, base64:false}, 	//適用開始日
			{name:'empJpnSrname', 							type:String, base64:true}, 		//従業員日本語姓 
			{name:'empJpnName', 							type:String, base64:true}, 		//従業員日本語名
			{name:'empJpnMidName', 							type:String, base64:true},		//従業員日本語ミドルネーム 
			{name:'empFrgnSrname', 							type:String, base64:true},		//従業員フリガナ姓 
			{name:'empFrgnName', 							type:String, base64:true}, 		//従業員フリガナ名 
			{name:'empFrgnMidName', 						type:String, base64:true}, 		//従業員フリガナミドルネーム 
			{name:'empEngSrname', 							type:String, base64:false}, 	//従業員英語姓 
			{name:'empEngName', 							type:String, base64:false}, 	//従業員英語名 
			{name:'empEngMidName', 							type:String, base64:false}, 	//従業員英語ミドルネーム 
			{name:'empAbrName', 							type:String, base64:true}, 		//従業員略名
			{name:'empFmlyName', 							type:String, base64:true}, 		//従業員戸籍名 
			{name:'gendCd', 								type:String, base64:false}, 	//性別コード 
			{name:'bday', 									type:String, base64:false}, 	//生年月日 
			{name:'empiSttsCd', 							type:String, base64:false}, //雇用形態コード 
			{name:'entryDate', 								type:String, base64:false}, //入社日 
			{name:'plgePresnDate', 							type:String, base64:false}, //誓約書提出日 
			{name:'workLocoCd', 							type:String, base64:false}, //勤務地コード
			{name:'workLocoAdres', 							type:String, base64:true}, 	//勤務地住所 
			{name:'rkCd', 									type:String, base64:false}, //ランクコード
			{name:'lastToWorkDate', 						type:String, base64:false}, //最終出社日
			{name:'rtiDate', 								type:String, base64:false}, //退職日
			{name:'cmntField', 								type:String, base64:true}, 	//コメント欄 
			], 
        dpt:[ 
    
            {name:'afiDptAplySrtDate',					    type:String, base64:false}, 	//適用開始日
            {name:'dptCd', name2:'dptName',					type:String, base64:false}, 	//部署コード 
            {name:'postCd', 								type:String, base64:false}, 	//役職コード 
            {name:'cncDptList', 							type:Array, 					//兼務部署リスト 
                list:[ 				
                    {name:'cncDptCd', 	name2:'cncDptName', type:String, 		base64:false,}, 	//兼務部署コード
                    {name:'cncPostCd', 						type:String, 		base64:false}, 	//兼務役職コード 
            ]},

            ],         
		expert:[
			{name:'exptAplySrtDate', 						type:String, base64:false}, //適用開始日
			{name:'gradeCd', 								type:String, base64:false}, //等級コード
			{name:'mnaSpvrFlag', 							type:Boolean, base64:false}, //管理監督者フラグ
		], 
		temporary:[ 
			{name:'tmpAgnCmpCd',name2:'tmpAgnCmpName',		type:String, base64:false},  //派遣元会社コード 派遣元会社名
			{name:'empiTermDciFlag', 						type:Boolean, base64:false}, //雇用期間の定めフラグ
			{name:'itrSchedTmpFlag', 						type:Boolean, base64:false}, //紹介予定派遣フラグ
			{name:'tmpCntrTermSrtDate', 				    type:String, base64:false},  //契約開始日
			{name:'tmpCntrTermExpiDate', 					type:String, base64:false},  //契約満了予定日
			{name:'idiCntDate', 							type:String, base64:false},  //個人抵触日
			{name:'hurRate', 								type:String, base64:false},  //時間単価
			{name:'uitCstRema', 							type:String, base64:true},   //単価備考
			{name:'flexAplyFlag', 							type:Boolean, base64:false}, //フレックス適用フラグ
			{name:'tmpBsiContField', 					    type:String, base64:true},   //業務内容欄 
			{name:'tmpBsiContDta', 							type:String, base64:true},   //業務内容詳細 
			{name:'tmpInfoRema', 						    type:String, base64:true},   //派遣社員情報備考
			{name:'cntrNtTgtFlag', 							type:Boolean, base64:false}, //契約書対象外フラグ
			{name:'webAttdNtTgtFlag', 						type:Boolean, base64:false}, //WEB勤怠対象フラグ
		],
		contract:[
			{name:'slaFormCd', 								type:String, base64:false}, //給与形態コード
			{name:'ocuCd', 									type:String, base64:false}, //職種コード 
			{name:'distMerh', 							type:String, base64:true},  //配布方法
			{name:'cntrBsiContField', 					type:String, base64:true},  //業務内容欄 
			{name:'mergePrintSprt', 						type:String, base64:true},  //差し込み印刷対応 
			{name:'lngEmpiTerm', 							type:String, base64:false}, //最長雇用期間 
			{name:'upIte', 									type:String, base64:false}, //更新間隔 
			{name:'cntrTermSrtDate', 						type:String, base64:false}, //契約期間開始日
			{name:'cntrTermExpiDate', 						type:String, base64:false}, //契約期間満了予定日 
			{name:'cntrInfoRema', 					        type:String, base64:true},  //契約社員情報備考
			{name:'gradeCd', 								type:String, base64:false}, //等級コード
			{name:'mnaSpvrFlag', 							type:Boolean, base64:false}, //管理監督者フラグ
		],
		accepted:[ 
			{name:'secFrmCmpCd', name2:'secFrmCmpName', 	type:String, base64:false}, //出向元会社コード 出向元会社名
			{name:'slaBaseCd', 								type:String, base64:false}, //給与基準コード 
			{name:'bsiTripExpeStndCd', 						type:String, base64:false}, //旅費基準コード 
			{name:'cntrFrmtCd', 					        type:String, base64:false}, //契約書フォーマットコード 
			{name:'secAcpCntrTermSrtDate', 					type:String, base64:false}, //出向(受)契約期間開始日
			{name:'secAcpCntrTermExpiDate', 			    type:String, base64:false}, //出向(受)契約期間満了日
			{name:'secAcpInfoRema', 						type:String, base64:true},  //出向(受)社員情報備考 
			{name:'mnaSpvrFlag', 							type:Boolean, base64:false}, //管理監督者フラグ
		], 
		assigned:[ 
			{name:'rtnDate', 								type:String, base64:false}, //帰任日
			{name:'secDestnCmpCd', name2:'secDestnCmpName', type:String, base64:false}, //出向先会社コード　出向先会社名
			{name:'secDestnDpt', 							type:String, base64:true},  //出向先部署名 
			{name:'cstBrd', 								type:String, base64:false}, //費用負担 
			{name:'bfSecAfiDptCd', name2:'bfSecAfiDptName', type:String, base64:false}, //出向前所属部署コード  出向前所属部署名
			{name:'secAsiInfoRema', 						type:String, base64:true},  //出向(出)社員情報備考
			{name:'crntSecTermSrtDate', 					type:String, base64:false}, //現出向期間開始日
			{name:'crntSecTermEndDate', 					type:String, base64:false}, //現出向期間終了日 
		],					
		absence:[ 
			{name:'absenceTermSrtDate', 					type:String, base64:false}, //休務/休職期間開始日
			{name:'absenceTermEndDate', 					type:String, base64:false}, //休務/休職期間終了日
			{name:'loaClasfCd', 							type:String, base64:false}, //休務/休職期間コード
		], 
		movein:[ 
			{name:'moveInDate', 							type:String, base64:false}, //転入日
			{name:'moveInRemaField', 						type:String, base64:true}, //転入日備考
		], 
		moveout:[ 
			{name:'moveOutDate', 							type:String, base64:false}, //転出日 
			{name:'moveOutRemaField', 						type:String, base64:true}, //転出日備考
		]
	}
    
    /* ====== 従業員一覧からID取得 ====== */
    const employeeNumber =  location.state.empNmb ;//従業員一覧からの従業員番号
    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */

    /* ====== 初期表示 ====== */ 
    useEffect(() => {
        /* マスタデータ取得 */
        getMaster();
        /* 詳細データ取得 */
        getDetail();
        if(location.state.data){
            setButtonState(location.state.editPlace);
            setValue('payload',location.state.data);
        };
        // setValue('payload.aplySrtDateList','2022-12-08')
        setLoading(true);

        // eslint-disable-next-line 
    },[]);

    /* ====== マスタの取得処理 ====== */
    const getMaster = async(date) => {
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
        const apiPath = '/search/getmaster';
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';

        /* キー */
        key.aplySrtDate = date ? date : null;
        //部署マスタ、役職マスタ、雇用形態マスタ、勤務地マスタ、ランクマスタ、人件費マスタ、取引先マスタ(出向出)、仕入先マスタ(出向受、派遣)、等級マスタ
        key.mstList = ['departmentMaster','postMaster','employmentStatusMaster','placeToWorkMaster','rankMaster','laborCostClassificationMaster','clientMaster','supplierMaster','gradeMaster'];

        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);
            /* APIリクエスト結果を判定 */
            if(result.isSuccessed){//APIリクエスト結果 = 正常
                const data = result.responseData.data.payload;
                const dataEdit = {};
                // data.forEach((item)=>{
                // 	dataEdit[item.code] = item;
                // })
                data.forEach((item)=>{
                    const object = {};
                    const list = [];
                    item.list.forEach((element)=>{
                        list.push({
                            value:element.value,
                            label:CFStringDecodeJP(element.label,base64Swicth)
                        });
                    })
                    object.code = item.code;
                    object.name = CFStringDecodeJP(item.name,base64Swicth);
                    object.list = list;
                    dataEdit[item.code] = object;
                })
                setMaster(dataEdit);
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }

        });
    };
    /* ====== APIから従業員データ取得 ====== */ 
    const getDetail = async(date) => {
        /* プログレスバー表示 */
        setProgress(true);

        /* リクエスト先 */
        const apiPath = '/employee/getdetailemployee';	//API Path

        /* リクエスト */
        const handlingInformation = {};
        const key = {};
        key.empNmb = employeeNumber;
        key.otpDate = date ? date : null;

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail; 
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'GET';

        /* リクエストパラメータ */
        const apiBody = { handlingInformation:handlingInformation, key: key };

        /* API処理開始 */
        await apiData.getDataPost(apiPath, apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);
            setSnackbarMessage({
                ...snackbarMessage,
                open:false,
                message:null,
                param1:null,
                level:null,
                type:null,
                afterFunction:null
            });
            /* APIリクエスト結果を判定 */
            if (result.isSuccessed) {//APIリクエスト結果 = 正常
                const detailData = result.responseData.data.payload;
                /* APIから取得したデータを、データ編集用配列に格納 */
                const employeeDataEdit = {};
                const affiliatedDepartmentDateEdit ={};
                /* 未来リストを格納　*/
                const editFutureList = {};
                 /*  データのチェック */
                const checkBoolean = (v) =>{
                    if(v === undefined || v === null){
                        return '';
                    }
                    else if(v === true){
                        return 'true';
                    }else if(v === false){
                        return 'false';
                    }
                    else{
                        return v;
                    }
                }
                const baseInfo = detailData.baseInfo;//従業員情報
                
                /*  API取得データ→画面表示データに変換 */
                const handleApiData = (list,apiData,editList) =>{
                    list.forEach((item)=>{
                        if(item.name2){
                            let value1;
                            if(item.base64){
                                value1 = apiData[item.name] ? CFStringDecodeJP(apiData[item.name],base64Swicth) : '';
                            }else{
                                value1 = checkBoolean(apiData[item.name]);
                            };

                            let value2;
                            if(item.base642){
                                value2 = apiData[item.name2] ? CFStringDecodeJP(apiData[item.name2],base64Swicth) : '';
                            }else{
                                value2 = checkBoolean(apiData[item.name2]);
                            };

                            editList[item.name] = value2 ? value1 + ' ' + value2 : value1;
                        }else{
                            let value;
                            if(item.base64){
                                value = apiData[item.name] ? CFStringDecodeJP(apiData[item.name],base64Swicth) : '';
                            }else{
                                if(item.type === 'date'){
                                    value = CFDateFormatEdit(apiData[item.name]);
                                }else if (item.type === Boolean) {
                                    value = apiData[item.name];
                                } else{
                                    value = checkBoolean(apiData[item.name]);
                                };
                            };
                            editList[item.name] = value;
                        }
                    });
                };


            /* ---------------------------------------- */
            /* ---------------- 基本情報 --------------- */
            /* ---------------------------------------- */

            /* 基本情報の適用日リスト */
            const baseApply = CFCreateApplyList(baseInfo.aplySrtDateList,'aplySrtDate'); //基本情報適用開始日リスト
            employeeDataEdit.applyList = baseApply.applyList;//適用日データ
            editFutureList.base = baseApply.futureList;//未来リスト

            /* 基本情報をAPI取得データ→画面表示データに変更 */
            const baseDetail = baseInfo.baseDetail;
            handleApiData(apiItem.base,baseDetail,employeeDataEdit);
            /* ---------------------------------------- */
            /* ------------- 所属部署情報 --------------- */
            /* ---------------------------------------- */
            const dptInfo = detailData.dptInfo;//所属部署情報
            /* 所属部署情報の適用日リスト */
            const dptApply = CFCreateApplyList(dptInfo.aplySrtDateList,'afiDptAplySrtDate'); //所属部署情報適用開始日リスト
            affiliatedDepartmentDateEdit.dptApplyList = dptApply.applyList;//適用日データ
            editFutureList.dpt = dptApply.futureList;//未来リスト
            /* 基本情報(兼務情報を除く)をAPI取得データ→画面表示データに変更 */
            const dptDetail = dptInfo.dptDetail;
            
            handleApiData(apiItem.dpt,dptDetail,affiliatedDepartmentDateEdit);
            /* 兼務情報をAPI取得データ→画面表示データに変更 */
            affiliatedDepartmentDateEdit.cncDptList = [];//兼務部署の入れ物用意
            
            dptDetail?.cncDptList?.forEach((row,i)=>{
                const object = {};
                apiItem.cncDptList.forEach((cont)=>{
                    if(cont.name2){
                        let value1;
                        if(cont.base64){
                            value1 = row[cont.name] ? CFStringDecodeJP(row[cont.name],base64Swicth):'';;
                        }else{
                             value1 = checkBoolean(row[cont.name]);
                        };
                        let value2;
                        if(cont.base642){
                            value2 = row[cont.name2] ? CFStringDecodeJP(row[cont.name2],base64Swicth) : '';
                        }else{
                            value2 = checkBoolean(row[cont.name2]);
                        };
                        object[cont.name] = value2 ? value1 + ' ' + value2 : value1;
                    }else{
                        let value = row[cont.name];
                        value = (value === null || value === undefined)  ? '' : value;
                        if(cont.base64){
                            object[cont.name] = value ?  CFStringDecodeJP(value,base64Swicth): '' ;
                        }else{
                            if(cont.type === 'date'){
                                value = CFUTCToDateInputFormatEdit(value);
                            };
                                
                            object[cont.name] = checkBoolean(value);

                        };
                    }

                });
                object.id = i;
                affiliatedDepartmentDateEdit.cncDptList.push(object);
            }); 
                       
            /* ---------------------------------------- */
            /* ---------- TableArray表示データ --------- */
            /* ---------------------------------------- */
            const absenceEdit = [];//休務/休職の入れ物
            const moveInEdit = [];//転入の入れ物
            const moveOutEdit = [];//転出の入れ物
            /* TableArrayのリスト */
            const arrayList = [
                {
                    id:'absence',
                    listName:'levList',
                    storage:absenceEdit
                },
                {
                    id:'movein',
                    listName:'moveInList',
                    storage:moveInEdit
                },
                {
                    id:'moveout',
                    listName:'moveOutList',
                    storage:moveOutEdit
                },
            ]
            
            /* TableArrayのリストを回して値をセット */
            arrayList.forEach((item)=>{
                detailData?.[item.listName].forEach((row,i)=>{
                    const data = {};
                    /* dataに値をセット */
                    apiItem[item.id].forEach((cont)=>{
                        if(cont.base64){
                            data[cont.name] = row[cont.name] ? CFStringDecodeJP(row[cont.name],base64Swicth):null;;
                        }else{
                            let value = row[cont.name];
                            if(cont.type === 'date'){
                                value = CFUTCToDateInputFormatEdit(value);
                            }
                            data[cont.name] = value;
                        };
                        data.id = i;
                    });
                    /* 各入れ物に入れていく */
                    item.storage.push(data);
                })
            });

            /* ---------------------------------------- */
            /* ------------- エキスパート情報 ------------ */
            /* ---------------------------------------- */

            
            const expertDataEdit = {};
           
            const exptInfo = detailData.exptInfo;//エキスパート情報
            if(exptInfo?.aplySrtDateList){
                /* エキスパートの適用日リスト */
                const expertApply = CFCreateApplyList(exptInfo.aplySrtDateList,'exptAplySrtDate');//エキスパート社員情用開始日リスト
                expertDataEdit.expertApplyList = expertApply.applyList;//適用開始日データ
                editFutureList.expert = expertApply.futureList;//未来リスト


                /* エキスパート情報をAPI取得データ→画面表示データに変更 */
                const exptDetail = exptInfo.exptDetail;//エキスパート社員情報
                handleApiData(apiItem.expert,exptDetail,expertDataEdit);
                
            };
            
            /* ---------------------------------------- */
            /* ---------------- 派遣情報 --------------- */
            /* ---------------------------------------- */							
            

            const temporaryDataEdit = {};
            const tmpInfo = detailData.tmpInfo;//派遣社員情報
            if(tmpInfo?.aplySrtDateList){
                /* 派遣情報の契約開始日リスト */
                const temporaryApply = CFCreateApplyList(tmpInfo.aplySrtDateList,'tmpCntrTermSrtDate');//派遣社員契約開始日リスト
                temporaryDataEdit.temporaryApplyList = temporaryApply.applyList;//契約開始日データ
                editFutureList.temporary = temporaryApply.futureList;//未来リスト
                
                /* 派遣情報をAPI取得データ→画面表示データに変更 */
                const tmpDetail = tmpInfo.tmpDetail;//派遣社員情報
                handleApiData(apiItem.temporary,tmpDetail,temporaryDataEdit);
            };
            
            /* ---------------------------------------- */
            /* -------------- 出向(出)情報 ------------- */
            /* ---------------------------------------- */
                    

            const assignedDataEdit = {};
            const asgInfo = detailData.asgInfo;//出向(出)社員情報
            if(asgInfo?.aplySrtDateList){
                /* 出向(出)情報の契約開始日リスト */
                const assignedApply = CFCreateApplyList(asgInfo.aplySrtDateList,'crntSecTermSrtDate');
                assignedDataEdit.assignedApplyList = assignedApply.applyList;//出向期間開始日データ
                editFutureList.assigned = assignedApply.futureList;//未来リスト

                /* 出向(出)情報をAPI取得データ→画面表示データに変更 */
                const asgDetail = asgInfo.asgDetail;//出向(出)社員情報
                handleApiData(apiItem.assigned,asgDetail,assignedDataEdit);
            };
            
            /* ---------------------------------------- */
            /* -------------- 出向(受)情報 -------------- */
            /* ---------------------------------------- */


            const acceptedDataEdit = {};
            const acceptedData = detailData.acpInfo;//出向(受)社員情報
            if(acceptedData){
                /* 出向(受)情報の契約開始日リスト */
                const acceptedApply = CFCreateApplyList(acceptedData.aplySrtDateList,'secAcpCntrTermSrtDate');
                acceptedDataEdit.acceptedApplyList = acceptedApply.applyList;//契約開始日データ
                editFutureList.accepted = acceptedApply.futureList;//未来リスト

                /* 出向(受)情報をAPI取得データ→画面表示データに変更 */
                const acpDetail = acceptedData.acpDetail;//出向(受)社員情報
                handleApiData(apiItem.accepted,acpDetail,acceptedDataEdit);
            };
            /* ---------------------------------------- */
            /* -------------- 契約社員情報 -------------- */
            /* ---------------------------------------- */

            const contractDataEdit = {};
            const contractData = detailData.contInfo; //契約社員情報                
            if(contractData?.aplySrtDateList){
                /* 契約情報の契約開始日リスト */
                const contractApply = CFCreateApplyList(contractData.aplySrtDateList,'cntrTermSrtDate');
                contractDataEdit.contractAppyList = contractApply.applyList;//契約期間開始日データ
                editFutureList.contract = contractApply.futureList;//未来リスト

                /* 出向(出)情報をAPI取得データ→画面表示データに変更 */
                const contDetail = contractData.contDetail;//契約社員情報
                handleApiData(apiItem.contract,contDetail,contractDataEdit);
            };                
            
            /* 契約継続フラグ */
            const cntrCntFlag = {flag:{}};
            cntrCntFlag.flag.tmpDetail = detailData?.tmpInfo?.tmpDetail?.cntrCntFlag;
            cntrCntFlag.flag.contDetail = detailData?.contInfo?.contDetail?.cntrCntFlag;
            cntrCntFlag.flag.acpDetail = detailData?.acpInfo?.acpDetail?.cntrCntFlag;
            cntrCntFlag.flag.asgDetail = detailData?.asgInfo?.asgDetail?.cntrCntFlag;

            /* データ送り用のマスターを作成 */
            const masterData = {
                base:employeeDataEdit,
                dpt:affiliatedDepartmentDateEdit,
                expert:expertDataEdit,
                temporary:temporaryDataEdit,
                assigned:assignedDataEdit,
                accepted:acceptedDataEdit,
                contract:contractDataEdit
            };
            const payload = {...employeeDataEdit,...affiliatedDepartmentDateEdit,...expertDataEdit,...temporaryDataEdit,...temporaryDataEdit,...assignedDataEdit,...acceptedDataEdit,...contractDataEdit};

            /* ペイロードをセット */
            setValue('payload',payload)
            /* 転入情報をセット */
            setValue("payload.movein",moveInEdit);
            /* 転出情報をセット */
            setValue("payload.moveout",moveOutEdit);
            /* 休務/休暇情報をセット */
            setValue("payload.absence",absenceEdit);
            /* 兼務部署をセット */
            setValue('payload.cncDptList',affiliatedDepartmentDateEdit.cncDptList);
            
            masterData.movein = moveInEdit;
            masterData.moveout = moveOutEdit;
            masterData.absence = absenceEdit;
            
            /* 表示用データ格納用stateにセット */
            setDataRow(masterData);
            /* ブロック別項目名 */
            const apply = ['base','dpt','expert','temporary','assigned','accepted','contract'];
            /* ブロック別フラグ */
            let deleteFlag = {
                base:false,
                dpt:false,                
                expert:false,
                temporary:false,
                assigned:false,
                accepted:false,
                contract:false
            };
            let copyFlag = { 
                base:false,
                dpt:false,                
                expert:false,
                temporary:false,
                assigned:false,
                accepted:false,
                contract:false
            };
            let editFlag = { 
                base:true,
                dpt:true,                
                expert:true,
                temporary:true,
                assigned:true,
                accepted:true,
                contract:true
            };
            
            apply.forEach((ap)=>{
                /*---- 登録ボタンの設定 ----*/
                /* 最も未来の日付を選択しているのならコピーして登録flagをtrueにセット */
                if(editFutureList[ap]){
                    if(editFutureList[ap][0] === masterData[ap][keyList[ap]]){
                        if(ap === 'assigned'){
                           if(masterData[ap].rtnDate){
                                copyFlag[ap] = true;
                           }
                        }else{
                            copyFlag[ap] = true;
                        }
                       
                    };
                };
                /* エキスパート社員のデータがない場合は、登録ボタンを表示する */
                if((Object.keys(masterData[ap]).length === 0 && ap === 'expert')){
                    copyFlag[ap] = true;
                };
                /* 出向(出)のデータがない場合は、登録ボタンを表示する */
                if((Object.keys(masterData[ap]).length === 0 && ap === 'assigned')){
                    copyFlag[ap] = true;
                };
              
                /*---- 削除ボタンの設定 ----*/
                /* 最も未来の日付を選択かつ現在適用中でない場合は削除flagをtrueにセット */
                if(masterData[ap][applyList[ap]]){
                    /* 未来の適用開始日と今選択している適用開始日が同一　*/
                    if(masterData[ap][applyList[ap]][0].value === masterData[ap][keyList[ap]]){
                        /* 今選択している適用開始日が現在適用中以外 */
                        if(masterData[ap][keyList[ap]] !== CFArrayFount(masterData[ap][applyList[ap]],'aplyFlag',true)?.value){
                            /* 出向(出)で帰任日が入力されていない場合は削除ボタンを表示 */
                            if(ap === 'assigned'){
                                if(!masterData[ap].rtnDate){
                                    deleteFlag[ap] = true;
                                }
                            }
                            /* 出向(出)以外は削除ボタンを表示*/
                            else{
                                deleteFlag[ap] = true;
                            }
                        };
                        /* 出向(出)の場合は初回の契約で帰任日が入力されるまでは削除ボタンを表示 */
                        if(ap === 'assigned' && assignedDataEdit?.assignedApplyList?.length === 1 && !masterData[ap].rtnDate){
                            deleteFlag[ap] = true;
                        }
                    };

                    /* 初回契約でなければ削除不可(出向(受)、契約、派遣、出向(出))　*/
                    if(ap !== 'base' && ap !== 'dpt' && ap !== 'expert' && masterData[ap].cntrCntFlag !== 'false'){
                        deleteFlag[ap] = false;
                    };
                };

                /*---- 編集ボタンの設定 ----*/
                /* 現在適用中以前のデータは編集不可 */
                if(masterData[ap][applyList[ap]]){
                    let applyFlag = false;
                    masterData[ap][applyList[ap]].forEach((item)=>{
                        if(masterData[ap][keyList[ap]]){
                            /* 現在~未来　*/
                            if(!applyFlag){
                                if(item.aplyFlag){
                                    applyFlag = true;
                                };
                            }
                            /* 過去 */
                            else{
                                if(item.value === masterData[ap][keyList[ap]]){
                                    editFlag[ap] = false;
                             
                                };
                            };

                        }else{
                            editFlag[ap] = false;
                        }
                        
                    });
                }else{
                    /* 初回契約でなければ編集不可　*/
                    if(masterData[ap].cntrCntFlag !== 'false'){
                        editFlag[ap] = false;
                    };
                }

            });

            /* flagがtrueの項目は、コピーして登録ボタンを表示する */
            setCopyButtonState(copyFlag);
             /* flagがtrueの項目は、削除ボタンを表示する */
            setdeleteButtonState(deleteFlag);
            /* flagがtrueの項目は、編集ボタンを表示する */
            setEditButtonState(editFlag);

            /* 等級コードが存在すれば値チェックする*/
            if(payload.gradeCd){
                onChangeGradeCd(payload.gradeCd);
            };
            setPageMode('read');
            setButtonState();

            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                })
            }
        });
    };
    /* ====== 更新ボタンを押した時の処理 ====== */
	const updateData = async() => {
        const data = newData;
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト*/
        const handlingInformation = {};
        let key;
        let payload;

        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'UPDATE';
        
        if(buttonState === 'absence' || buttonState === 'movein' || buttonState === 'moveout' ){
            key = [];
            payload = [];
           confirm.data.forEach((cnf,i)=>{
                /* 変更点があるものだけを送る　*/
                if(Object.keys(confirm.flags[i]).some(e =>confirm.flags[i][e] === true)){
                    const keyObject = {};
                    const payloadObject = {};
                    if(cnf.dataType === 'delete'){
                        keyObject[keyList[buttonState]] = cnf[keyList[buttonState]];
                        keyObject.empNmb = employeeNumber
                        key.push(keyObject);
                        payloadObject[keyList[buttonState]] = cnf[keyList[buttonState]];
                        updateApiItem[buttonState].forEach((item)=>{

                            let value = item.type(cnf[item.name]);
                            if(value === undefined || value === '未入力' || value === ''){
                                payloadObject[item.name] = null;
                            }else if(item.type === String){
                                if(item.base64){
                                    payloadObject[item.name] = CFStringEncodeJP(value,base64Swicth);   
                                }else{
                                    payloadObject[item.name] = value;
                                }
                            };
                            payloadObject.ctgr = 'delete';
                        });
                        payload.push(payloadObject);

                    }else if(cnf.dataType === 'register'){
                        keyObject[keyList[buttonState]] = cnf[`${keyList[buttonState]}New`];
                        keyObject.empNmb = employeeNumber
                        key.push(keyObject);

                        updateApiItem[buttonState].forEach((item)=>{

                            let value = item.type(cnf[`${item.name}New`]);
                            if(value === undefined || value === ''|| value === '未入力'|| value === 'undefined'){
                                payloadObject[item.name] = null;
                            }else if(item.type === String){
                                if(item.base64){
                                    payloadObject[item.name] = CFStringEncodeJP(value,base64Swicth);   
                                }else{
                                    payloadObject[item.name] = value;
                                }
                            };
                            payloadObject.ctgr = 'register';

                        });
                        payload.push(payloadObject);
                    }else{
                        keyObject[keyList[buttonState]] = cnf[keyList[buttonState]];
                        keyObject.empNmb = employeeNumber
                        key.push(keyObject);
                        updateApiItem[buttonState].forEach((item)=>{
                            let value = cnf[`${item.name}New`] ? item.type(cnf[`${item.name}New`]) : item.type(cnf[item.name]);
                            if(value === undefined || value === '' || value === '未入力' || value === 'undefined'){
                                payloadObject[item.name] = null;
                            }else if(item.type === String){
                                if(item.base64){
                                    payloadObject[item.name] = CFStringEncodeJP(value,base64Swicth);   
                                }else{
                                    payloadObject[item.name] = value;
                                }
                            };
                            payloadObject.ctgr = 'update';
                        });
                        payload.push(payloadObject);
                    };
                };
           });
            
        }else{
            key = {};
            if(pageMode === 'registerConfirm'){
                key[keyList[buttonState]] = data[keyList[buttonState]] ;
            }else{
                key[keyList[buttonState]] = dataRow[buttonState][keyList[buttonState]];
            };

            key.empNmb = employeeNumber;
            payload = {};
            updateApiItem[buttonState].forEach((item)=>{
                let value = item.type(data[item.name] === 'true' ? true:data[item.name] === 'false'? false : data[item.name]);
                if(value === undefined || value === '' || value === 'null' || value === 'undefined'){
                    payload[item.name] = null;
                }else if(item.type === String){
                    value = item.name2 ? value.split(' ')[0] :value; 
                    if(item.base64){
                        payload[item.name] = CFStringEncodeJP(value,base64Swicth);   
                    }else{
                        payload[item.name] = value;
                    }
                }else if(item.type === Boolean){
                    payload[item.name] = value;
                }else if(item.type === Array){
                    payload[item.name] = [];
                    data[item.name].forEach((row)=>{
                        const object = {};
                        item.list.forEach((listItem)=>{
                            value = listItem.type(row[listItem.name])
                            if(value === undefined || value === ''){
                                object[listItem.name] = null;
                            }else if(listItem.type === String){
                                value = value.split(' ')[0];
                                if(item.base64){
                                    object[listItem.name]  = CFStringEncodeJP(value,base64Swicth);
                                }else{
                                    object[listItem.name]  = value;
                                }
                            }
                        })
                        payload[item.name].push(object);
                    })
                    
                };
            })
        };
        /* APIパス */
        const apiPath = {
            base:'/employee/updateemployee',
            dpt:'/employee/updateaffiliateddepartment',					
            expert:'/employee/updateexpertemployee',								
            contract:'/employee/updatecontractemployee',											
            assigned:'/employee/updateassignedemployee',											
            accepted:'/employee/updateacceptedemployee',											
            temporary:'/employee/updatetemporaryemployee',						
            absence:'/employee/updateloe',						
            movein:'/employee/updatemovein',						
            moveout:'/employee/updatemoveout',						
        };
        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key, payload:payload};
        /* API処理開始 */
        await apiData.getDataPost(apiPath[buttonState], apiBody, (result) => {
            /* プログレスバー非表示 */
            setProgress(false);
            if(result.isSuccessed){

                navigate('/common/completion', {
                    state:{
                        title: pageMode === 'registerConfirm' ? '従業員情報詳細登録完了' : '従業員情報詳細編集完了', 
                        message: pageMode === 'registerConfirm' ? screenDisplayMessage('CMNI006'):screenDisplayMessage('CMNI004'), 
                        button:[
                            {name: '一覧画面へ戻る', path: '/employee/information/list'},
                            {name: '詳細画面へ戻る', path: '/employee/information/detail',state:{empNmb:employeeNumber}},
                        ]
                        },
                    replace:true
                 },);
            }else{
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    $1:result.responseData ? result.responseData.data.metadata: '',//取得件数
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                })
            }
        });
    };


    /* ====== 削除処理 ====== */
    const deleteData = async() => {
        /* プログレスバー表示 */
        setProgress(true);
        /* リクエスト先 */
        const apiPath = {
            base:'/employee/deleteemployee',
            dpt:'/employee/deleteaffiliateddepartment',					
            expert:'/employee/deleteexpertemployee',								
            contract:'/employee/deletecontractemployee',											
            assigned:'/employee/deleteassignedemployee',											
            accepted:'/employee/deleteacceptedemployee',											
            temporary:'/employee/deletetemporaryemployee',						
            absence:'/employee/deleteloe',
            movein:'/employee/deletemovein',
            moveout:'/employee/deletemoveout',						
        };
        /* リクエスト*/
        const handlingInformation = {};
        const key = {};
        
        /* 操作情報 */
        handlingInformation.hndEmpMailAdrs = userInfoValue.mail;
        handlingInformation.hndEmpFullName = CFStringEncodeJP(userName,base64Swicth);
        handlingInformation.sreId = screenId;
        handlingInformation.hndId = 'DELETE';
        /* キー */
        key.empNmb = employeeNumber;
        key[keyList[buttonState]] = newData[keyList[buttonState]];

        /* リクエストパラメータ */
        const apiBody = {handlingInformation:handlingInformation, key:key};

        /* API処理開始 */
        await apiData.getDataPost(apiPath[buttonState], apiBody, (result) => {
            /* APIリクエスト結果を判定 */
            if(result.isSuccessed){//APIリクエスト結果 = 正常
                navigate('/common/completion', {
                    state:{
                        title: '従業員情報詳細削除完了', 
                        message: screenDisplayMessage('CMNI005'), 
                        button:[
                            {name: '一覧画面へ戻る', path: '/employee/information/list'},
                            {name: '詳細画面へ戻る', path: '/employee/information/detail',state:{empNmb:employeeNumber}},
                        ]
                        },
                    replace:true
                 },);
                
            }else{//APIリクエスト結果 = 異常
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:result,//APIによるエラー
                    type: 1,//APIエラー時:1,それ以外:2 
                    level:'error',//エラースナックバー
                });
            }

        });
    };

    const checkArrayData = (data) =>{
        /* dataRowのコピー(階層が深いのでこの形式) */
        var oldData = JSON.parse(JSON.stringify(dataRow[buttonState]));
        var newData = JSON.parse(JSON.stringify({...dataRow[buttonState],...data[buttonState]}));
        var oldDataEdit = {};
        var newDataEdit = {};
        if(Array.isArray(oldData)){
            oldData = [];
            newData = [];
            const keys = [];
            updateApiItem[buttonState].forEach((item)=>{
                keys.push(item.name);
            })
            /* 配列データの変更を確認して調整する処理 */
            CFCheckArrayData(dataRow[buttonState],data[buttonState],oldData,newData,keys)
        }else{
            updateApiItem[buttonState].forEach((item)=>{
                /* item.listがある時 */
                if(item.list){
                    oldData[item.name] = [];
                    newData[item.name] = [];
                    const keys = [];
                    item.list.forEach((listItem)=>{
                        keys.push(listItem.name);
                    });
                    /* 配列データの変更を確認して調整する処理 */
                    CFCheckArrayData(dataRow[buttonState][item.name],data[item.name],oldData[item.name],newData[item.name],keys);
                }
                /* item.listがない時 */
                else{
                    oldData[item.name] = dataRow[buttonState][item.name] ? `${dataRow[buttonState][item.name]}` : null;
                    newData[item.name] = data[item.name] ? `${data[item.name]}`: null;

                    oldDataEdit[item.name] =  dataRow[buttonState][item.name] ? `${dataRow[buttonState][item.name]}` : null;
                    newDataEdit[item.name] = data[item.name] ? `${data[item.name]}`: null;
                }
                
            });
        };
        return {
            oldData:oldData,
            newData:newData,
            oldDataEdit:oldDataEdit,
            newDataEdit:newDataEdit
        }
    } 
    /* ====== データ変更の確認 ====== */
    const checkEditData = (data) =>{
        if(pageMode === 'register' && buttonState === 'assigned'){
            const oldData = {};
            const newData = {};
            const keys = [];
            updateApiItem[buttonState].forEach((item)=>{
                newData[item.name] = data[item.name];
                keys.push(item.name)
            });
        
            let changeFlags = checkChangeFlag(oldData,newData,keys);
            let changeData = confirmChange(changeFlags,oldData,newData,keys);
            setConfirm(
                {
                    flags:changeFlags,
                    data:changeData
                }
            );
            /* 変更後データの格納 */
            setNewData(data);
            /* 確認モードに変更　*/
            setPageMode('registerConfirm');
            /* ペイロードのリセット */
            reset();
        }else{
            const checkData = checkArrayData(data);
            /* 重複チェック */
            const duplicateList = {
                movein:'moveInDate',
                moveout:'moveOutDate',
                absence:'absenceTermSrtDate',
            };
            /* 空のobjectを排除する処理 */
            const avoidEmptyObject = (data) =>{
                const array = [];
                data.forEach((row)=>{
                    Object.keys(row).length !== 0 && array.push(row);
                })
                return array;
            }
            /* 変更点がない場合　*/
            if(CFJsonIgnore(checkData.oldData) === CFJsonIgnore(checkData.newData)){
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:'CMNW004',
                    type: 2,//APIエラー時:1,それ以外:2 
                });
            /* 重複エラーがある場合 */
            }else if(Array.isArray(checkData.newData) && (CFJsonIgnore(avoidEmptyObject(checkData.newData)) !== CFJsonIgnore(CFArrayDuplicateCheck(avoidEmptyObject(checkData.newData),duplicateList[buttonState])))){
                /* スナックバー表示 */
                setSnackbarMessage({      
                    ...snackbarMessage,
                    open:true,
                    message:'CMNW005',
                    type: 2,//APIエラー時:1,それ以外:2 
                });
            }else{
            /* 変更点がある場合　*/
                /* keyの抽出 */
                const keys = Array.isArray(checkData.oldData) ? (Object.keys(checkData.oldData[0]).length > 0 ? Object.keys(checkData.oldData[0]) : Object.keys(checkData.newData[0])):Object.keys(checkData.oldData);
                /* 変更があればchangeFlagをtrueにする */
                let changeFlags = checkChangeFlag(checkData.oldData,checkData.newData, keys);
                let changeData = confirmChange(changeFlags,checkData.oldData,checkData.newData, keys);
                if(changeFlags.cncDptList){
                    const compareData = dataRow[buttonState].cncDptList.length  > data.cncDptList.length ? dataRow[buttonState].cncDptList: data.cncDptList;
                    changeFlags.cncDptList = checkChangeFlag(checkData.oldData.cncDptList, checkData.newData.cncDptList,Object.keys(compareData[0]));
                    changeData.cncDptList = confirmChange(changeFlags.cncDptList,checkData.oldData.cncDptList,checkData.newData.cncDptList, Object.keys(compareData[0]));
                    /* 項目cncDptListNewを削除 */
                    delete changeData.cncDptListNew;
                };
                setConfirm(
                    {
                        flags:changeFlags,
                        data:changeData
                    }
                );
                /* 変更後データの格納 */
                setNewData(data);
                /* 確認モードに変更　*/
                pageMode === 'register' ? setPageMode('registerConfirm') : setPageMode('updateConfirm');
                // /* ペイロードのリセット */
                reset();
            };
        };
    };

    /* ====== 更新ボタンを押した時の処理 ====== */
    const onClickSubmit = (row) => {
        const data = row.payload;
        if(pageMode === 'register'){
            const oldAplyDate = new Date(dataRow[buttonState][keyList[buttonState]]);
            const newAplyDate = new Date(data[keyList[buttonState]]);
            var today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            /* 登録しようとした適用日が今日よりも前 */
            // if(today > newAplyDate){
            //     /* スナックバー表示 */
            //     setSnackbarMessage({      
            //      ...snackbarMessage,
            //      open:true,
            //      message:'CMNW001',
            //      type: 2,//APIエラー時:1,それ以外:2 
            //      level:'error'//エラースナックバー
            //      });
            // }else
             if(Object.keys(dataRow[buttonState]).length  === 0){
                /* データ確認処理　*/
                checkEditData(data);
            }
            else if(dataRow[buttonState][applyList[buttonState]].some(e=>new Date(e.value).getTime() === newAplyDate.getTime())){
                 /* スナックバー表示 */
                 setSnackbarMessage({      
                  ...snackbarMessage,
                  open:true,
                  message:'CMNW006',
                  type: 2,//APIエラー時:1,それ以外:2 
                  level:'error'//エラースナックバー
                  })
              }
             /* 登録しようとした適用日がコピーしたデータよりも前 */
            else if( oldAplyDate > newAplyDate ){
                 /* コピーしたデータが削除されても良いかを確認　*/
                 const afterFunc = () =>{
                     /* データ確認処理　*/
                     checkEditData(data);
                 }
                 /* 確認ダイアログ表示 */
                 setDialogMessage({      
                     ...dialogMessage,
                     open:true, 
                     message:'CMNC003',//メッセージID(commonFunctionより対象のメッセージ)
                     afterFunc:afterFunc,
                     pattern: 2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                 });
            }else{
                /* データ確認処理　*/
                checkEditData(data);
            };
        }else{
            /* データ確認処理　*/
            checkEditData(data);
        };
    };

    /* ====== キャンセル・戻るボタン押した時の処理 ====== */
    const onClickLeft = () => {
        /* 戻るボタン押下時 */
        if(pageMode === 'read'){
            navigate('/employee/information/list');
        /* 戻るボタン押下時(更新) */
        }else if(pageMode === 'updateConfirm' ){
            setValue('payload',newData)
            /* fieldsを使っている部分は再セット */
            Object.keys(newData).forEach((item)=>{
                    if(Array.isArray(newData[item])){
                        setValue(`payload.${item}`,newData[item])
                    };
                })
            setPageMode('edit');
        /* 戻るボタン押下時(登録) */
        }else if(pageMode === 'registerConfirm' || pageMode === 'deleteConfirm'){
            setValue('payload',newData)
            /* fieldsを使っている部分は再セット */
            Object.keys(newData).forEach((item)=>{
                if(Array.isArray(newData[item])){
                    setValue(`payload.${item}`,newData[item])
                };
            })
            setPageMode('register');

        /* キャンセルボタン押下時(更新) */
        }else{
            const afterCancel = () =>{
                /* 閲覧モードに戻る　*/
                setPageMode('read');
                /* ボタンステータスを空にする */
                setButtonState();
                /* データの取得し直し */
                getDetail();
                /* エラーのクリア */
                clearErrors();
            }
            /* 変更点のチェック */
            const checkData = checkArrayData(getValues('payload'));
            if(CFJsonIgnore(checkData.oldData) === CFJsonIgnore(checkData.newData)){
                afterCancel();
            }else{
                /* 更新確認ダイアログ表示 */
                setDialogMessage({      
                    ...dialogMessage,
                    open: true,
                    message: 'CMNC001',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:afterCancel,
                    pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                });
            }
            

        }
        
    };
    /* ====== 削除ボタンを押した時の処理 ====== */
    const onClickDelete = (id) => {
        setButtonState(id);
        /* 変更後のデータをnewDataに入れておく */
		setNewData(getValues('payload'));
        /* deleteモードに変更 */
		setPageMode('deleteConfirm');
        /* dataRowにリセット */
		setValue('payload',dataRow)
    };
    /* ====== 履歴ボタン押下 ====== */
    const onClickHistory = () => {
        navigate('/employee/historyemployees',{state: {empNmb:employeeNumber}})
    };

    /* ====== コピーして登録ボタンを押した時の処理 ====== */
    const onClickCopy = (id) => {
        let today = new Date();//今日の日付を取得
        // yyyy-mm-ddの形に変える
        const year = today.getFullYear();//年を取得
        const month = ('00' + (today.getMonth()+1)).slice(-2)//月を取得
        const day = ('00' + (today.getDate())).slice(-2);//日を取得
        today = year + '-' + month + '-' + day//それぞれをフォーマットになるよう結合する
        /* ステート更新 */
        setPageMode('register');
        setButtonState(id);
    };

    /* ====== 追加ボタンを押した時の処理 ====== */
    const onClickRegist = () => {
        let today = new Date();//今日の日付を取得
        // yyyy-mm-ddの形に変える
        const year = today.getFullYear();//年を取得
        const month = ('00' + (today.getMonth()+1)).slice(-2)//月を取得
        const day = ('00' + (today.getDate())).slice(-2);//日を取得
        today = year + '-' + month + '-' + day//それぞれをフォーマットになるよう結合する
        /* ステート更新 */
        setPageMode('register');
        setButtonState('assigned');
        apiItem.assigned.forEach((item)=>{
            setValue(`payload.${item.name}`, '');
        })
        setValue('payload.crntSecTermSrtDate',today);
    };
    /* ====== 編集ボタンを押した時の処理 ====== */
    const onClickUpdate = (id) => {
        /* 編集モードに変更 */
        if(buttonState !== id){
            /* ページモード変更 */
            setPageMode('edit');
            /* ボタンステータス変更 */
            setButtonState(id)
            /* 出力日変更 */
            let date;
            switch(id){
                case 'base' :
                    date = getValues('payload.aplySrtDate');
                ;
                break;
                case 'dpt' :
                    date = getValues('payload.afiDptAplySrtDate');
                break;
                case 'expert' :
                    date = getValues('payload.exptAplySrtDate');
                break;
                case 'temporary' :
                    date = getValues('payload.tmpCntrTermSrtDate');
                break;
                case 'assigned' :
                    date = getValues('payload.crntSecTermSrtDate');
                break;
                case 'accepted' :
                   date = getValues('payload.secAcpCntrTermSrtDate');
                break;
                case 'contract' :
                   date = getValues('payload.cntrTermSrtDate');
                break;
                default:
                    date = '';
                break;
            };
            setValue('payload.otpDate',date);//出力日を適用開始日に連動して変更
            getMaster(date);//マスタデータ取得
        }else{
            const afterCancel = () =>{
                /* 閲覧モードに戻る　*/
                setPageMode('read');
                /* ボタンステータスを空にする */
                setButtonState();
                /* データの取得し直し */
                getDetail();
                /* エラーのクリア */
                clearErrors();
            }
            /* 変更点のチェック */
            const checkData = checkArrayData(getValues('payload'));
            if(CFJsonIgnore(checkData.oldData) === CFJsonIgnore(checkData.newData)){
                afterCancel();
            }else{
                /* 更新確認ダイアログ表示 */
                setDialogMessage({      
                    ...dialogMessage,
                    open: true,
                    message: 'CMNC001',//メッセージID(commonFunctionより対象のメッセージ)
                    afterFunc:afterCancel,
                    pattern:2//1：OKボタンのみ表示　2：OKとキャンセルボタンを表示 3：OKとキャンセルと一時保存ボタンを表示
                });
            }
        };
    };

    /* ====== 適用中データに戻す ====== */
    const onClickNowApply = () =>{
        getDetail();
    };
    /* ====== 適用日ボタン押下 ====== */
    const onChangeApply = (event) => {
        getMaster(event.target.value);//マスタデータ取得
        getDetail(event.target.value);
    };

    /* ====== 出力日を変更した時の処理 ====== */
    const onChangeOtpDate = (event) =>{
        const validate = CFArrayFount(patternCheckMaster.list,'value','date');
        //バリデーションを正常に通った
        if(event.target.value.match(new RegExp(validate.detailItemValidationTypeCode))){
            getMaster(event.target.value);//マスタデータ取得
            getDetail(event.target.value);//詳細データ取得
        };
    };
    /* ====== コピーして登録ボタンから適用開始日を変更した時の処理 ====== */
    const onChangeApplyDate = (event) =>{
        const validate = CFArrayFount(patternCheckMaster.list,'value','date');
        //バリデーションを正常に通った
        if(event.target.value.match(new RegExp(validate.detailItemValidationTypeCode))){
            setValue('payload.otpDate',event.target.value);//出力日を適用開始美に連動して変更
            getMaster(event.target.value);//マスタデータ取得
        };
    };
    /* ====== 等級を変更した時の処理 ====== */
    const onChangeGradeCd = (event) =>{
        const value = event.target ? event.target.value : event;
        /* 等級の値チェック */
        //'A0','A1','A2','A3'
        if(['A0','A1','A2','A3'].some(item=>item === value)){
            //管理監督者:false 編集可
            setDisableItem({...disableItem,mnaSpvrFlag:true});
            setValue('payload.mnaSpvrFlag',true)
        }
        //値なし
        else if(value === '' || value === '0' || value === 'Z'){
            //管理監督者:任意選択 編集可
            setDisableItem({...disableItem,mnaSpvrFlag:false});
        }
        //上記以外
        else{
            //管理監督者:false 編集不可
            setDisableItem({...disableItem,mnaSpvrFlag:true});
            setValue('payload.mnaSpvrFlag',false)
        }
    };
    
    /* ---------------------------------------------------- */
    /* ----------------------- data ------------------------ */
    /* ---------------------------------------------------- */
    /*====== アンカーコンテンツ ======*/
    const anchorContents = [
        // {id:'applyDate',name:'適用開始日',  status:'applyDate'},
        {id:'base',name:'基本情報',  status:'base'},
        {id:'dpt',name:'所属部署情報',status:'dpt'},
        {id:'absence',name:'休務/休職情報',  status:'absence'},
        {id:'movein',name:'転入情報',  status:'movein'},
        {id:'moveout',name:'転出情報',  status:'moveout'},
        // {id:'retirement',name:'退職情報',  status:'retirement'},
        // {id:'dispatch',name:'派遣社員',  status:'dispatch'},
        // {id:'temporary',name:'契約社員',  status:'temporary'},
        // {id:'assigned',name:'出向(受)社員',  status:'assigned'},
        // {id:'contract',name:'出向(出)社員',  status:'contract'},
    ];

    /*====== fieldArrayの設定 ======*/
    const fieldList = [
        {id:'absence',blockTitle:'休務/休職情報'},
        {id:'movein',blockTitle:'転入情報'},
        {id:'moveout',blockTitle:'転出情報'}
    ];
    const fieldArrayConfig = {
        field:{
            movein:MoveInFields,
            moveout:MoveOutFields,
            absence:AbsenceFields
        },
        append:{
            movein:MoveInAppend,
            moveout:MoveOutAppend,
            absence:AbsenceAppend
        },
        remove:{
            movein:MoveInRemove,
            moveout:MoveOutRemove,
            absence:AbsenceRemove
        },
        update:{
            movein:MoveInUpdate,
            moveout:MoveOutUpdate,
            absence:AbsenceUpdate
        }
    };
    /*====== タイトル設定 ======*/
    const titleName = () => {
        let result;
        switch(pageMode){
            case 'read' :
                const employmentStatusMaster = master?.employmentStatusMaster;//雇用形態マスタ
                const empiSttsName = CFArrayFount(employmentStatusMaster?.list,'value', dataRow.base.empiSttsCd)?.label;
                result = `従業員情報詳細 雇用形態:${empiSttsName}`;
            break;
            case 'registerConfirm' :
                result = '従業員情報詳細登録確認';
            break;
            case 'updateConfirm' :
                result = '従業員情報詳細更新確認';
            break;
            case 'deleteConfirm' :
                result = '従業員情報詳細削除確認';
            break;
            case 'edit' :
                result = '従業員情報詳細編集';
            break;
            case 'register' :
                result = '従業員情報詳細登録';
            break;
            default:
                result = '';
            break;
        };
        return result;
    };

    /*====== テーブルの設定(基本情報、契約系) ======*/
    const checkTableConfig = (id,mode,state) =>{
        let result;
        /* ======== テーブルの設定 ======== */
        /*------ ヘッダの設定 ------*/
        // id       : 項目名
        // rowSpan  : 2~ (縦に結合)
        // colSpan	: 2~ (横に結合)
        // align	: 整列(横方向) Center/inherit/justify/left/right
        // sortTable: true(ソート)
        // fixed	: 位置固定 true
        // left		: 左からの位置	0~
        // right	: 右からの位置 0~
        // width    : セルの幅
        // label1	: 表示名(1段目)
        // label2	: 表示名(2段目)
        // mark     : 入力必須を表す*を表示　true

        /* ====== テーブルヘッダーを定義 ====== */
        /* ====== 兼務部署テーブルヘッダー ====== */
        const headDataCncDptList =[
            { id: 'cncDptCd',align: 'left', width: '515px',  label1:'部署',},//部署
            { id: 'cncPostCd', align: 'left', width: '120px', label1: '役職', sizeNone: false},//役職
        ]; 
        /* ====== 兼務部署編集テーブルヘッダー ====== */
        const headDataCncDptListUpdate =[
            { id: 'deleteIcon', align: 'center', width: '50px',label1: '削除'},//ファンクションボタン
            { id: 'cncDptCd', align: 'left', width: '475px',  label1:'部署',required:true},//部署
            { id: 'cncPostCd', align: 'left', width: '120px', label1: '役職', sizeNone: false},//役職
        ];
        /*====== BodyCellの設定 ======*/
        // name		    : 項目名
        // name2		: 項目名2 値を２つ受け取りたい場合
        // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
        // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
        // width        : selectの幅調整用
        // color        : 文字の色
        // backgroundColor: 背景の色
        // checkBox     : チェックボックスの名前  *input,checkBox
        // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
        // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
        // func         : 処理 *button,iconButton,select
        // value		: btnFuncで受け取りたい値 *button,iconButton

        /* ====== 兼務部署テーブルデータ ====== */
        const bodyDataCncDptList = [
            { name: 'cncDptCd',type: 'label',  align: 'left'},
            { name: 'cncPostCd', type:'edit',master:postMaster, align: 'left'},
        ];
        /* ====== 兼務部署編集テーブルデータ ====== */
        const bodyDataCncDptListUpdate = [
            { name: 'deleteIcon', type: 'deleteIcon', align: 'center'},
            { name: 'cncDptCd', type: 'inputList',  align: 'left',master:departmentMaster, maxLength:128,required:true, placeholder: '128文字まで'},
            { name: 'cncPostCd', type: 'select', align: 'left',master:postMaster},
        ];
        /* ====== LeftTitleテーブルの設定 ====== */
        //id:idを指定
        //label:左側に表示するタイトル*
        //list:右側に表示するコンテンツのリスト *
        //name:項目名
        //name2:項目名(type:categoryLabelを選択時のみ指定　minorCategory)
        //title:inputなどの隣に表示するタイトル
        //type:表示タイプ label/input/select/date/datetime/categoryLabel(問合せ情報問合せ種別用) *
        //rightLabel:inputなどの隣に表示するラベル 例：メールドメインなど
        //disable:変更不可にする true/false
        //readOnly:ラベル風にする　true/false（select/date/datetime)
        //width:幅の変更をする(inputのみ)
        /* ====== LeftTitleテーブルのデータ ====== */
        /* ====== 基本情報データ詳細 ====== */
        const employeeInformationTableConfig = [
            /*出力日 */
            {
                id:'row0', 
                label:'出力日',
                list:[
                    {name:'otpDate',type:'date',onChange:onChangeOtpDate}
                ]
            },
            /*適用日 */
            {
                id:'row1', 
                label:'適用開始日',
                list:[
                    {
                        name:'aplySrtDate',
                        type:'applySelect',
                        applyList: 'applyList',
                        clickType: 'base',
                    }
                ]
            },
            /*従業員番号 */
            {
                id:'row2', 
                label:'従業員番号', 
                list:[
                    {name:'empNmb',   type:'label'},
                ]
            },
            /*シメイ */
            {
                id:'row3', 
                label:'フリガナ', 
                list:[
                    {name:'empFrgnSrname', type:'label',title:'セイ：'},
                    {name:'empFrgnName', type:'label',title:'メイ：'},
                    {name:'empFrgnMidName', type:'label',title:'ミドルネーム：'},

                ]
            },
            /*氏名 */
            {
                id:'row4', 
                label:'氏名', 
                list:[
                    {name:'empJpnSrname', type:'label',title:'姓：'},
                    {name:'empJpnName', type:'label',title:'名：'},
                    {name:'empJpnMidName', type:'label',title:'ミドルネーム：'},
                ]
            },
            /*従業員名(ローマ) */
            {
                id:'row5', 
                label:'英名',
                list:[
                    {name:'empEngSrname', type:'label',title:'Surname：'},
                    {name:'empEngName', type:'label',title:'Given Name：'},
                    {name:'empEngMidName', type:'label',title:'Middle Name：'},
                ]
            },
            /*従業員名(略名) */
            {
                id:'row6', 
                label:'略名',
                list:[
                    {name:'empAbrName', type:'label'},
                ]
            },
            /*戸籍名 */
            {
                id:'row7', 
                label:'戸籍名', 
                list:[
                    {name:'empFmlyName', type:'label'}
                ]
            },
            /*性別 */
            {
                id:'row8', 
                label:'性別', 
                list:[
                    {name:'gendCd', type:'edit',master:genderCode},
                ]
            },
            /*生年月日 */
            {
                id:'row9', 
                label:'生年月日', 
                list:[
                    {name:'bday', type:'dateLabel'},
                    ]
            },
            /*雇用形態 */            
            {
                id:'row13', 
                label:'雇用形態', 
                list:[
                    {name:'empiSttsCd', type:'edit',master:employmentStatusMaster},
                ]
            },
            /*入社日(開始日) */
            {
                id:'row14', 
                label:'入社日(開始日)', 
                list:[
                    {name:'entryDate', type:'dateLabel'},
                ]
            },
            /*誓約書提出日 */
            {
                id:'row15', 
                label:'誓約書提出日', 
                list:[
                    {name:'plgePresnDate', type:'dateLabel'},
                ]
            },
            
            /*勤務地 */
            {
                id:'row16', 
                label:'勤務地', 
                list:[
                    {name:'workLocoCd', type:'edit',master:placeToWorkMaster},
                ]
            },
            /*勤務地住所 */
            {id:'row17', 
            label:'勤務地住所', 
            list:[
                    {name:'workLocoAdres',type:'label'},
                ]
            },
            /*ランク */
            {id:'row18', 
            label:'ランク', 
            list:[
                    {name:'rkCd', type:'edit',master:rankMaster},
                ]
            },
            /*人事No */
            {
                id:'row20', 
                label:'人事稟議番号', 
                list:[
                    {name:'hrAprvNmb', type:'label'},
                ]
            },
            /*稟議起案時費用 */
            {
                id:'row21', 
                label:'稟議起案時費用', 
                list:[
                    {name:'aprvOrgTimeCst', type:'moneyLabel'},
                ]
            },
            /*最終出社日 */
            {
                id:'row22', 
                label:'最終出社日', 
                list:[
                    {name:'lastToWorkDate', type:'dateLabel'},
                ]
            },
            /*退職日(終了日) */
            {
                id:'row23', 
                label:'退職日(終了日)', 
                list:[
                    {name:'rtiDate', type:'dateLabel'},
                ]
            },
            /*コメント */
            {
                id:'row24', 
                label:'コメント欄', 
                list:[
                    {name:'cmntField', type:'label'},
                ]
            },

        ];
        /* ====== 基本情報データ確認 ====== */
        /* 適用開始日indexを取得 */
        const aplySrtDateIndex = employeeInformationTableConfig.findIndex(e=>e.label === '適用開始日');
        /* 基本情報データをコピー　*/
        const employeeInformationTableConfigCopy = [...employeeInformationTableConfig];
        /* 適用開始日indexを元にデータを置換 */
        employeeInformationTableConfigCopy.splice(aplySrtDateIndex,1,{
            id:'row1', 
            label:'適用開始日',
            list:[
                {name:'aplySrtDate', type:'dateLabel'}
            ]
        });
        employeeInformationTableConfigCopy.splice(0,1);
        /* 出力日の削除 */
        const employeeCnfTableConfig = employeeInformationTableConfigCopy;


        /* ====== 所属部署情報データ詳細 ====== */
        const affiliatedDepartmentInformationTableConfig = [
            /*適用日 */
            {
                id:'row1', 
                label:'適用開始日',
                list:[
                    {
                        name:'afiDptAplySrtDate',
                        type:'applySelect',
                        applyList: 'dptApplyList',
                        clickType: 'dpt',
                    }
                ]
            },
            /*部署 */
            {
                id:'row10', 
                label:'部署', 
                list:[
                    {name:'dptCd', name2:'dptName', type:'label'},
                ]
            },
            /*人件費区分 */
            {
                id:'row19', 
                label:'人件費区分', 
                list:[
                    {name:'lboCstClasfName',type:'label'},
                ]
            },
            /*役職 */
            {
                id:'row11', 
                label:'役職', 
                list:[
                    {name:'postCd', type:'edit',master:postMaster},
                ]
            },
            /*兼務部署 */
            {
                id:'row12', 
                label:'兼務部署', 
                list:[
                    {
                        name:'cncDptList', 
                        type: 'table',
                        tableHeader:headDataCncDptList,
                        tableBody:bodyDataCncDptList,
                    },
                ]
            },

        ];
        
        /* ====== 所属部署情報データ確認 ====== */
        /* 適用開始日indexを取得 */
        const aplySrtDateIndexCopy = affiliatedDepartmentInformationTableConfig.findIndex(e=>e.label === '適用開始日');
        /* 所属部署情報データをコピー　*/
        const affiliatedDepartmentInformationTableConfigCopy = [...affiliatedDepartmentInformationTableConfig];
        /* 適用開始日indexを元にデータを置換 */
        affiliatedDepartmentInformationTableConfigCopy.splice(aplySrtDateIndexCopy,1,{
            id:'row1', 
            label:'適用開始日',
            list:[
                {name:'afiDptAplySrtDate', type:'dateLabel'}
            ]
        });
        // affiliatedDepartmentInformationTableConfigCopy.splice(0,1);
        /* 出力日の削除 */
        const  affiliatedDepartmentCnfTableConfig = affiliatedDepartmentInformationTableConfigCopy;


        /* ====== 基本情報データ登録 ====== */
        const employeeRegisterTableConfig =
        [
            // /*適用日 */
            {
                id:'row1', 
                label:'適用開始日',
                required:true,
                list:[
                    {name:'aplySrtDate',type:'date',pattern:'date',onChange:onChangeApplyDate},
                ]
            },
            /*従業員番号 */
            {
                id:'row2', 
                label:'従業員番号', 
                required:true,
                list:[
                    {name:'empNmb',type:'label'},
                ]
            },
            /*シメイ */
            {
                id:'row3', 
                label:'フリガナ', 
                required:true,
                list:[
                    {name:'empFrgnSrname', type:'input',title:'セイ：',maxLength:50,pattern:'zenkakuKatakana', placeholder: '50文字まで',required:true},
                    {name:'empFrgnName', type:'input',title:'メイ：',maxLength:50,pattern:'zenkakuKatakana', placeholder: '50文字まで',required:true},
                    {name:'empFrgnMidName', type:'input',title:'ミドルネーム：',maxLength:50,pattern:'zenkakuKatakanaSpace', placeholder: '50文字まで'},
                ]
            },
            /*従業員名(漢字) */
            {
                id:'row4', 
                label:'氏名',
                required:true,
                list:[
                    {name:'empJpnSrname', type:'input',title:'姓：',maxLength:50, placeholder: '50文字まで',required:true},
                    {name:'empJpnName', type:'input',title:'名：', maxLength:50, placeholder: '50文字まで',required:true},
                    {name:'empJpnMidName', type:'input',title:'ミドルネーム：', maxLength:50, placeholder: '50文字まで'},

                ]
            },
            /*従業員名(ローマ) */
            {
                id:'row5', 
                label:'英名',
                required:true,
                list:[
                    {name:'empEngSrname', type:'input',title:'Surname：',maxLength:50,pattern:'english', placeholder: '50文字まで',required:true},
                    {name:'empEngName', type:'input',title:'Given Name：',maxLength:50,pattern:'english', placeholder: '50文字まで',required:true},
                    {name:'empEngMidName', type:'input',title:'Middle Name：',maxLength:50,pattern:'englishSpace', placeholder: '50文字まで'},
                ]
            },
            /*従業員名(略名) */
            {
                id:'row6', 
                label:'略名',
                required:true,
                list:[
                    {name:'empAbrName', type:'input',maxLength:50, placeholder: '50文字まで',required:true},
                ]
            },
            /*従業員名(戸籍名) */
            {
                id:'row7', 
                label:'戸籍名',
                list:[
                    {name:'empFmlyName', type:'input',maxLength:50, placeholder: '50文字まで'},
                ]
            },
            /*性別 */
            {
                id:'row8', 
                label:'性別',
                    required:true,
                    list:[
                    {name:'gendCd', type:'radioButton',required:true,master:genderCode},
                ]
            },
            /*生年月日 */
            {
                id:'row9', 
                label:'生年月日', 
                list:[
                    {name:'bday', type:'date',pattern:'date'},
                ]
            },
            /*雇用形態 */
            {
                id:'row13', 
                label:'雇用形態',
                required:true, 
                list:[
                    {name:'empiSttsCd', type:'select',required:true,master:employmentStatusMaster},
                ]
            },
            /*入社日(開始日) */
            {
                id:'row14', 
                label:'入社日(開始日)', 
                required:true,
                list:[
                    {name:'entryDate', type:'date',pattern:'date',requireCheckItem: true,required:true},
                ]
            },
            /*誓約書提出日 */
            {
                id:'row15', 
                label:'誓約書提出日', 
                list:[
                    {name:'plgePresnDate', type:'date',pattern:'date',startDateEql:'entryDate'},
                ]
            },
            /*勤務地 */
            {
                id:'row16', 
                label:'勤務地', 
                required:true,
                list:[
                    {name:'workLocoCd', type:'select',required:true,master:placeToWorkMaster},
                ]
            },
            /*勤務地住所 */
            {
                id:'row17', 
                label:'勤務地住所',
                list:[
                    {name:'workLocoAdres', type:'input', maxLength:255,placeholder:'255文字まで',width:'620px'},
                ]
            },
            /*ランク */
            {
                id:'row18', 
                label:'ランク', 
                list:[
                    {name:'rkCd', type:'select',master:rankMaster},
                ]
            },
            /*人事稟議No */
            {
                id:'row20', 
                label:'人事稟議番号', 
                list:[
                    {name:'hrAprvNmb', type:'label'},
                ]
            },
            /*稟議起案時費用 */
            {
                id:'row21', 
                label:'稟議起案時費用', 
                list:[
                    {name:'aprvOrgTimeCst', type:'label'},
                ]
            },
            /*最終出社日 */
            {
                id:'row22', 
                label:'最終出社日', 
                list:[
                    {name:'lastToWorkDate', type:'date',pattern:'date'},
                ]
            },
            /*退職日(終了日) */
            {
                id:'row23', 
                label:'退職日(終了日)', 
                list:[
                    {name:'rtiDate', type:'date',pattern:'date', startDateEql:'aplySrtDate'},
                ]
            },
            /*コメント欄 */
            {
                id:'row24', 
                label:'コメント欄', 
                list:[
                    {name:'cmntField', type:'textarea',maxLength:255,width:'100%',placeholder:'255文字まで'},
                ]
            },

        ];

 
        /* ====== 基本情報データ編集(適用開始日をlabelのままにする場合) ====== */
        /* 基本情報データをコピー　*/
        const aplySrtDateIndex2 = employeeRegisterTableConfig.findIndex(e=>e.label === '適用開始日')
        const employeeUpdateTableConfigCopy = [...employeeRegisterTableConfig];
        /* 適用開始日indexを元にデータを置換 */
        employeeUpdateTableConfigCopy.splice(aplySrtDateIndex2,1,{
            id:'row1', 
            label:'適用開始日',
            list:[
                {name:'aplySrtDate', type:'dateLabel'}
            ]
        });
        const employeeUpdateTableConfig = employeeUpdateTableConfigCopy;

       /* ====== 所属部署情報データ登録 ====== */
       const affiliatedDepartmentTableConfig = 
       [
           // /*適用日 */
           {
               id:'row1', 
               label:'適用開始日',
               required:true,
               list:[
                   {name:'afiDptAplySrtDate',type:'date',pattern:'date',onChange:onChangeApplyDate},
               ]
           },
           /*部署 */
           {
               id:'row10', 
               label:'部署', 
               required:true,     
               list:[
                   {name:'dptCd', name2:'dptName', type:'inputList',title:'',master:departmentMaster,maxLength:128, buttonType:'button',placeholder:'128文字まで',required:true},
               ]
           },
            /*人件費区分 */
            {
                id:'row19', 
                label:'人件費区分', 
                list:[
                    {name:'lboCstClasfName',type:'label'},
                ]
            },
           /*役職 */
           {
               id:'row11', 
               label:'役職',
               list:[
                   {name:'postCd', type:'select',master:postMaster},
               ]
           },
           /*兼務部署 */
           {
               id:'row12', 
               label:'兼務部署',
               list:[
                   {
                       name:'cncDptList', 
                       type:'tableArray',
                       tableHeader:headDataCncDptListUpdate,
                       tableBody:bodyDataCncDptListUpdate,
                       editMode:true,
                       showRight:true,
                   },
               ]
           },

       ];        

        /* ====== 所属部署情報データ編集(適用開始日をlabelのままにする場合) ====== */
        /* 所属部署情報データをコピー　*/
        const aplySrtDateIndex3 = affiliatedDepartmentTableConfig.findIndex(e=>e.label === '適用開始日')
        const affiliatedDepartmentUpdateTableConfigCopy = [...affiliatedDepartmentTableConfig];
        /* 適用開始日indexを元にデータを置換 */
        affiliatedDepartmentUpdateTableConfigCopy.splice(aplySrtDateIndex3,1,{
            id:'row1', 
            label:'適用開始日',
            list:[
                {name:'afiDptAplySrtDate', type:'dateLabel'}
            ]
        });
        const affiliatedDepartmentUpdateTableConfig = affiliatedDepartmentUpdateTableConfigCopy;

        /* ====== エキスパート社員データ ====== */
        const expertInformationTableConfig = 
            [     
                /* 適用開始日 */
                {
                    id:'row1', 
                    label:'適用開始日',
                    list:[
                        {
                            name:'exptAplySrtDate',   
                            type:'applySelect',
                            applyList: 'expertApplyList',
                            clickType: 'expert',
                        },
                    ]
                },
                /* 等級 */
                {
                    id:'row2', 
                    label:'等級',
                    list:[
                        {name:'gradeCd', type:'edit', master:groupradeMaster},
                    ]
                },
                /* 管理監督者フラグ */
                {
                    id:'row3', 
                    label:'管理監督者',
                    list:[
                        {name:'mnaSpvrFlag',type:'checkbox', disabled: true},
                    ],
                },
            ]

        /* ====== エキスパート情報データ確認 ====== */
        /* 適用開始日indexを取得 */
        const expertExpertApplyIndex = expertInformationTableConfig.findIndex(e=>e.label === '適用開始日');
        /* エキスパート情報データをコピー　*/
        const expertInformationTableConfigCopy = [...expertInformationTableConfig];
        /* 適用開始日indexを元にデータを置換 */
        expertInformationTableConfigCopy.splice(expertExpertApplyIndex,1,{
            id:'row1', 
            label:'適用開始日',
            list:[
                {name:'exptAplySrtDate', type:'dateLabel'}
            ]
        });
        const expertCnfTableConfig = expertInformationTableConfigCopy;
        
        /* 選択肢'-'の削除 */
        // const groupradeMasterForExpert =JSON.parse(JSON.stringify(groupradeMaster));
        // const groupradeMasterIndex = groupradeMasterForExpert?.list.findIndex(e=>e.label === '-');
        // if(groupradeMasterIndex !== -1){
        //     groupradeMasterForExpert?.list.splice(groupradeMasterIndex,1);
        // };
        /* ====== エキスパート社員データ ====== */
        const expertRegisterInformationTableConfig =
            [
                /*適用開始日 */
                {
                    id:'row1', 
                    label:'適用開始日',
                    required:true,
                    list:[
                        {name:'exptAplySrtDate',type: 'date',pattern:'date',required:true,onChange:onChangeApplyDate}
                    ],
                },
                /* 等級 */
                {
                    id:'row2', 
                    label:'等級',
                    required: true,
                    list:[
                        {name:'gradeCd',type:'select',master:groupradeMaster,required: true,onChange:onChangeGradeCd},
                    ],
                },
                /* 管理監督者フラグ */
                {
                    id:'row3', 
                    label:'管理監督者',
                    list:[
                        {name:'mnaSpvrFlag',type:'checkbox',disabled:disableItem?.mnaSpvrFlag},
                    ],
                },
            ];
            
        /* ====== エキスパート情報データ編集 ====== */
        /* エキスパート情報データをコピー　*/
        const expertRegisterInformationTableConfigCopy = [...expertRegisterInformationTableConfig];
        /* 適用開始日indexを元にデータを置換 */
        expertRegisterInformationTableConfigCopy.splice(expertExpertApplyIndex,1,{
            id:'row1', 
            label:'適用開始日',
            list:[
                {name:'exptAplySrtDate', type:'dateLabel'}
            ]
        });
        const expertUpdateInformationTableConfig = expertRegisterInformationTableConfigCopy;
        /* ====== 派遣社員データ ====== */
        const tmpInformationTableConfig = 
            [     /*適用開始日 */
                /*派遣元会社 */
                {
                    id:'row1', 
                    label:'派遣元会社名', 
                    list:[
                        {name:'tmpAgnCmpCd', type:'label'},
                    ]
                },
                /*雇用期間の定め */
                {
                    id:'row2', 
                    label:'雇用期間の定め', 
                    list:[
                        {name:'empiTermDciFlag',   type:'edit',master:employmentTermDisitionFlag},
                    ]
                },
                /*紹介予定派遣 */
                {
                    id:'row3', 
                    label:'紹介予定派遣',
                    list:[
                        {name:'itrSchedTmpFlag', type:'edit',master:introductionScheduleTemporaryFlag},
                    ]
                },
                {
                    id:'row4', 
                    label:'契約開始日', 
                    list:[
                        {name:'tmpCntrTermSrtDate',
                        type:'applySelect',
                        applyList: 'temporaryApplyList',
                        clickType: 'temporary',
                    },
                    ]
                },
                /*契約満了予定日 */
                {
                    id:'row5', 
                    label:'契約満了予定日', 
                    list:[
                        {name:'tmpCntrTermExpiDate',   type:'dateLabel'},
                    ]
                },
                /*個人抵触日 */
                {
                    id:'row6', 
                    label:'個人抵触日',
                    list:[
                        {name:'idiCntDate',   type:'dateLabel'},
                    ]
                },
                /*派遣先責任者 */
                {
                    id:'row7', 
                    label:'派遣先責任者',
                    list:[
                        {name:'tmpFirstRspPsnEmpNmb', type:'label'},
                    ]
                },
                /*指揮命令者 */
                {
                    id:'row8', 
                    label:'指揮命令者',
                    list:[
                        {name:'ledrEmpNmb', type:'label'},
                    ]
                },
                /*時間単価 */
                {
                    id:'row9', 
                    label:'時間単価', 
                    list:[
                        {name:'hurRate', type:'label'},
                    ]
                },
                /*初回時間単価 */
                {
                    id:'row9', 
                    label:'初回時間単価', 
                    list:[
                        {name:'frsFirstHurRate', type:'label'},
                    ]
                },
                /*時間単価備考 */
                {
                    id:'row10', 
                    label:'時間単価備考', 
                    list:[
                        {name:'uitCstRema',   type:'label'},
                    ]
                },
                /*フレックス適用 */
                {
                    id:'row11', 
                    label:'フレックス適用', 
                    list:[
                        {name:'flexAplyFlag',type:'edit',master:flexApplyFlag},
                    ]
                },
                /*業務内容 */
                {
                    id:'row12', 
                    label:'業務内容', 
                    list:[
                        {name:'tmpBsiContField',   type:'label'},
                    ]
                },
                /*業務内容詳細 */
                {
                    id:'row13', 
                    label:'業務内容詳細', 
                    list:[
                        {name:'tmpBsiContDta',   type:'label', maxHeight: '400px'},
                    ]
                },
                /*備考 */
                {
                    id:'row14', 
                    label:'派遣社員情報 備考',
                    list:[
                        {name:'tmpInfoRema',   type:'label'},
                    ]
                },
                /*契約対象外 */
                {
                    id:'row15', 
                    label:'契約書対象外', 
                    list:[
                        {name:'cntrNtTgtFlag',type:'checkbox',disabled: true},
                    ]
                },
                /*WEB勤怠対象外 */
                {
                    id:'row16', 
                    label:'WEB勤怠対象外', 
                    list:[
                        {name:'webAttdNtTgtFlag',type:'checkbox',disabled: true},
                    ]
                },
            ]
        // const changeRequired  = (value) =>{
        // 	const tableConfigCopy = [...temporaryUpdateInformationTableConfig];
        // 	const index = tableConfigCopy.findIndex((obj) => obj.id === 'idiCntDate');
        // 	const requiredFlag = (value === 'true');
        // 	tableConfigCopy[index].required = requiredFlag;
        // 	tableConfigCopy[index].list[0].required = requiredFlag;
        // 	setTemporaryTableData(tableConfigCopy);
        // }

        /* ====== 派遣情報データ確認 ====== */
        /* 契約開始日indexを取得 */
        const tmpCntrsrtDateIndex = tmpInformationTableConfig.findIndex(e=>e.label === '契約開始日');
        /* 派遣情報データをコピー　*/
        const tmpInformationTableConfigCopy = [...tmpInformationTableConfig];
        /* 契約開始日indexを元にデータを置換 */
        tmpInformationTableConfigCopy.splice(tmpCntrsrtDateIndex,1,{
            id:'row4', 
            label:'契約開始日', 
            list:[
                {name:'tmpCntrTermSrtDate', type:'dateLabel'}
            ]
        });
        const tmpCnfTableConfig = tmpInformationTableConfigCopy;

        /* ====== 派遣社員データ登録 ====== */
        const temporaryRegisterInformationTableConfig =
        [   
            /*派遣元会社 */
            {
                id:'row1', 
                label:'派遣元会社名', 
                list:[
                    {name:'tmpAgnCmpCd', type:'inputList',title:'',master:supplierMaster,maxLength:50, buttonType:'button', required: true,placeholder:'50文字まで'},
                ],
                required: true
            },
            /*雇用期間の定め */
            {
                id:'row2', 
                label:'雇用期間の定め', 
                list:[
                    {name:'empiTermDciFlag',   type:'radioButton', master:employmentTermDisitionFlag,required: true },
                ],
                required: true
            },
            /*紹介予定派遣 */
            {
                id:'row3', 
                label:'紹介予定派遣',
                list:[
                    {name:'itrSchedTmpFlag',   type:'radioButton', master:introductionScheduleTemporaryFlag, required: true},
                ],
                required: true
            },
            /*適用開始日 */
            {
                id:'row4', 
                label:'契約開始日', 
                list:[
                    {name:'tmpCntrTermSrtDate',type: 'date', pattern:'date'},
                ],
            },
            /*契約満了予定日 */
            {
                id:'row5',
                label:'契約満了予定日', 
                list:[
                    {name:'tmpCntrTermExpiDate', type: 'date',pattern:'date',startDate:'tmpCntrTermSrtDate'},
                ]
            },
            /*個人抵触日 */
            {
                id:'row6',
                label:'個人抵触日',
                list:[
                    {name:'idiCntDate', type:'date',pattern:'date',requireCheckItem:'empiTermDciFlag',requireCheckValue:'true'},
                ]
            },
            /*派遣先責任者 */
            {
                id:'row7', 
                label:'派遣先責任者',
                list:[
                    {name:'tmpFirstRspPsnEmpNmb', type:'label'},
                ]
            },
            /*指揮命令者 */
            {
                id:'row8', 
                label:'指揮命令者',
                list:[
                    {name:'ledrEmpNmb', type:'label'},
                ]
            },
            /*時間単価 */
            {
                id:'row9', 
                label:'時間単価', 
                list:[
                    {name:'hurRate', type:'input',maxLength:8,pattern:'number',placeholder:'8文字まで'},
                ]
            },
            /*初回時間単価 */
            {
                id:'row9', 
                label:'初回時間単価', 
                list:[
                    {name:'frsFirstHurRate', type:'label'},
                ]
            },
            /*時間単価備考 */
            {
                id:'row10', 
                label:'時間単価備考', 
                list:[
                    {name:'uitCstRema',   type:'input',maxLength:255,placeholder:'255文字まで',width:'620px',},
                ]
            },
            /*フレックス適用 */
            {
                id:'row11', 
                label:'フレックス適用', 
                list:[
                    {name:'flexAplyFlag',   type:'radioButton',master:flexApplyFlag},
                ]
            },
            /*業務内容 */
            {
                id:'row12', 
                label:'業務内容', 
                list:[
                    {name:'tmpBsiContField',  type:'input',maxLength:255,placeholder:'255文字まで',width:'620px',},
                ]
            },
            /*業務内容詳細 */
            {
                id:'row13', 
                label:'業務内容詳細', 
                list:[
                    {name:'tmpBsiContDta',type:'textarea',maxLength:2048,placeholder:'2048文字まで',width:'100%'},
                ]
            },
            /*派遣社員情報 備考 */
            {
                id:'row14', 
                label:'派遣社員情報 備考', 
                list:[
                    {name:'tmpInfoRema',type:'input',maxLength:255,placeholder:'255文字まで',width:'620px',},
                ]
            },
            /*契約対象外 */
            {
                id:'row15', 
                label:'契約書対象外', 
                list:[
                    {name:'cntrNtTgtFlag',   type:'checkbox'},
                ]
            },
            /*WEB勤怠対象外 */
            {
                id:'row16', 
                label:'WEB勤怠対象外', 
                list:[
                    {name:'webAttdNtTgtFlag',   type:'checkbox'},
                ]
            },
        ];

        /* ====== 派遣情報データ編集 ====== */
        /* 派遣情報データをコピー　*/
        const temporaryRegisterInformationTableConfigCopy = [...temporaryRegisterInformationTableConfig];
        /* 契約開始日indexを元にデータを置換 */
        temporaryRegisterInformationTableConfigCopy.splice(tmpCntrsrtDateIndex,1,{
            id:'row4', 
            label:'契約開始日', 
            list:[
                {name:'tmpCntrTermSrtDate', type:'dateLabel'}
            ]
        });
        const temporaryUpdateInformationTableConfig = temporaryRegisterInformationTableConfigCopy;

        /* ====== 出向社員(出)社員データ ====== */
        const assignedInformationTableConfig =
            [   
                /*出向開始日 */
                {
                    id:'row1',
                    label:'出向開始日',
                    list:[
                        {name:'secSrtDate',type:'dateLabel'}
                    ]
                },
                /*帰任日*/
                {
                    id:'row2', 
                    label:'帰任日', 
                    list:[
                        {name:'rtnDate',   type:'dateLabel'},
                    ]
                },
                /*出向先会社名 */
                {
                    id:'row3', 
                    label:'出向先会社名', 
                    list:[
                        {name:'secDestnCmpCd', type:'label'},
                        
                    ]
                },
                /*出向先部署名*/
                {
                    id:'row4', 
                    label:'出向先部署名', 
                    list:[
                        {name:'secDestnDpt',   type:'label'},
                    ]
                },
                /*費用負担(TC:出向先) */
                {
                    id:'row5', 
                    label:'費用負担(TC:出向先)', 
                    list:[
                        {name:'cstBrd',   type:'label'},
                    ]
                },
                /*出向前所属部署 */
                {
                    id:'row6', 
                    label:'出向前所属部署', 
                    list:[
                        {name:'bfSecAfiDptCd',   type:'label'},
                    ]
                },
                /*備考 */
                {
                    id:'row7', 
                    label:'備考', 
                    list:[
                        {name:'secAsiInfoRema', type:'label'},
                    ]
                },
                /*出向期間開始日 */
                {
                    id:'row8', 
                    label:'出向期間開始日',
                    list:[
                        {name:'crntSecTermSrtDate',
                        type:'applySelect',
                        applyList: 'assignedApplyList',
                        clickType: 'assigned'
                    },
                    ]
                },
                /*出向期間終了日 */
                {
                    id:'row9', 
                    label:'出向期間終了日', 
                    list:[
                        {name:'crntSecTermEndDate', type:'dateLabel'},
                    ]
                },
                
                
            ]

        /* ====== 出向(出)情報データ確認 ====== */
        /* 出向期間開始日indexを取得 */
        const assignedCrntSecTermsrtDateIndex = assignedInformationTableConfig.findIndex(e=>e.label === '出向期間開始日');
        /* 出向(出)情報データをコピー　*/
        const assignedInformationTableConfigCopy = [...assignedInformationTableConfig];
        /* 出向期間開始日indexを元にデータを置換 */
        assignedInformationTableConfigCopy.splice(assignedCrntSecTermsrtDateIndex,1,{
            id:'row8', 
            label:'出向期間開始日',
            list:[
                {name:'crntSecTermSrtDate', type:'dateLabel'}
            ]
        });
        assignedInformationTableConfigCopy.splice(0,1);
        const assignedCnfTableConfig = assignedInformationTableConfigCopy;

        /* ====== 出向社員(出)社員データ登録 ====== */
        const assignedRegisterInformationTableConfig =
            [
                /*帰任日*/
                {
                    id:'row2', 
                    label:'帰任日',
                    list:[
                        {name:'rtnDate',   type:'date',pattern:'date',startDateEql:'crntSecTermEndDate'},
                    ]
                },
                
                /*出向先会社名 */
                {
                    id:'row3', 
                    label:'出向先会社名', 
                    list:[
                        {name:'secDestnCmpCd', type:'inputList',title:'',master:clientMaster,maxLength:50,placeholder:'50文字まで', buttonType:'button'},
                    ]
                },
                /*出向先部署名*/
                {
                    id:'row4', 
                    label:'出向先部署名', 
                    list:[
                        {name:'secDestnDpt', type:'input', maxLength:128,placeholder:'128文字まで',width:'620px'},
                    ]
                },
                /*費用負担(TC:出向先) */
                {
                    id:'row5', 
                    label:'費用負担(TC:出向先)', 
                    list:[
                        {name:'cstBrd', type:'input',maxLength:6,minLength:4,placeholder:'50:50',pattern:'workload'},
                    ]
                },
                /*出向前所属部署 */
                {
                    id:'row6', 
                    label:'出向前所属部署', 
                    list:[
                        {name:'bfSecAfiDptCd',type:'inputList', master:departmentMaster,maxLength:128,placeholder:'128文字まで'},
                    ]
                },
                /*備考 */
                {
                    id:'row7', 
                    label:'備考', 
                    list:[
                        {name:'secAsiInfoRema', type:'input',maxLength:255,placeholder:'255文字まで',width:'620px'},
                    ]
                },
                /*出向期間開始日 */
                {
                    id:'row8', 
                    label:'出向期間開始日',
                    required: true,
                    list:[
                        {name:'crntSecTermSrtDate',type: 'date', pattern:'date',requireCheckItem: true, onChange:onChangeApplyDate},
                    ]
                },
                /*出向期間終了日 */
                {
                    id:'row9', 
                    label:'出向期間終了日',
                    list:[
                        {name:'crntSecTermEndDate', type: 'date',pattern:'date',startDate:'crntSecTermSrtDate',endDate:'rtnDate'},
                    ]
                },


                
            ]
        /* ====== 出向(出)編集データ====== */
        /* 適用開始日indexを取得 */
        const secSrtDateIndex2 = assignedRegisterInformationTableConfig.findIndex(e=>e.label === '出向期間開始日');
        /* 基本情報データをコピー　*/
        const assignedRegisterInformationTableConfigCopy = [...assignedRegisterInformationTableConfig];
        /* 適用開始日indexを元にデータを置換 */
        assignedRegisterInformationTableConfigCopy.splice(secSrtDateIndex2,1, {
            id:'row8', 
            label:'出向期間開始日',
            list:[
                {name:'crntSecTermSrtDate', type:'dateLabel'}
            ]
        });
        
        /*出向開始日 */
        assignedRegisterInformationTableConfigCopy.unshift({
            id:'row1', 
            label:'出向開始日', 
            list:[
                {name:'secSrtDate',type:'dateLabel'}
            ]
        });
        const assignedUpdateInformationTableConfig = assignedRegisterInformationTableConfigCopy;
        /* ====== 出向社員(受)社員データ ====== */
        const acceptedInformationTableConfig =
        [     
            /*出向元会社 */
            {
                id:'row1', 
                label:'出向元会社名',
                list:[
                    {name:'secFrmCmpCd', type:'label'},
                ]
            },
            /*給与基準*/
            {
                id:'row2', 
                label:'給与基準', 
                list:[
                    {name:'slaBaseCd',type:'edit',master:salaryBaseCode},
                ]
            },
            /*旅費基準 */
            {
                id:'row3', 
                label:'旅費基準', 
                list:[
                    {name:'bsiTripExpeStndCd',type:'edit',master:travelExpensesCode},
                ]
            },
            /*契約書フォーマット*/
            {
                id:'row4', 
                label:'契約書フォーマット', 
                list:[
                    {name:'cntrFrmtCd',type:'edit',master:contractFormatCode},
                ]
            },
            /*初回契約開始日 */
            {
                id:'row5', 
                label:'初回契約開始日', 
                list:[
                    {name:'secAcpFirstCntrSrtDate',   type:'dateLabel'},
                ]
            },
            /*適用開始日 */
            {
                id:'row6', 
                label:'現契約開始日',
                list:[
                    {name:'secAcpCntrTermSrtDate',
                    type:'applySelect',
                    applyList: 'acceptedApplyList',
                },
                ]
            },
            /*現契約満了予定日 */
            {
                id:'row7', 
                label:'現契約満了予定日', 
                list:[
                    {name:'secAcpCntrTermExpiDate',   type:'dateLabel'},
                ]
            },
            /*出向社員情報 備考 */
            {
                id:'row8', 
                label:'出向社員情報 備考', 
                list:[
                    {name:'secAcpInfoRema', type:'label'},
                ]
            },
            /*管理監督者 */
            {
                id:'row9', 
                label:'管理監督者',
                list:[
                {name:'mnaSpvrFlag',type:'checkbox', disabled: true},
                ]
            },
        
        ]

        /* ====== 出向(受)情報データ確認 ====== */
        /* 現契約開始日indexを取得 */
        const secAcpCntrTermSrtDateIndex = acceptedInformationTableConfig.findIndex(e=>e.label === '現契約開始日');
        /* 出向(受)情報データをコピー　*/
        const acceptedInformationTableConfigCopy = [...acceptedInformationTableConfig];
        /* 現契約開始日indexを元にデータを置換 */
        acceptedInformationTableConfigCopy.splice(secAcpCntrTermSrtDateIndex,1,{
            id:'row6', 
            label:'現契約開始日',
            list:[
                {name:'secAcpCntrTermSrtDate', type:'dateLabel'}
            ]
        });
        const acceptedCnfTableConfig = acceptedInformationTableConfigCopy;

        /* ====== 出向社員(受)社員登録データ ====== */
        const acceptedRegisterInformationTableConfig =
            [
                /*出向元会社 */
                {
                    id:'row1', 
                    label:'出向元会社名', 
                    list:[
                        {name:'secFrmCmpCd', type:'inputList',title:'',master:supplierMaster,maxLength:50, buttonType:'button',placeholder:'50文字まで'},
                    ]
                },
                /*給与基準*/
                {
                    id:'row2', 
                    label:'給与基準', 
                    list:[
                        {name:'slaBaseCd',type:'radioButton',master:salaryBaseCode,maxLength:200},
                    ]
                },
                /*旅費基準 */
                {
                    id:'row3', 
                    label:'旅費基準', 
                    list:[
                        {name:'bsiTripExpeStndCd',type:'radioButton',master:travelExpensesCode,maxLength:200},
                    ]
                },
                /*契約書フォーマット*/
                {
                    id:'row4', 
                    label:'契約書フォーマット', 
                    list:[
                        {name:'cntrFrmtCd',type:'radioButton',master:contractFormatCode, maxLength:200},
                    ]
                },
                /*適用開始日 */
                {
                    id:'row5', 
                    label:'初回契約開始日', 
                    list:[
                        {name:'secAcpFirstCntrSrtDate', type: 'dateLabel'},
                    ]
                },
                /*契約開始日 */
                {
                    id:'row6', 
                    label:'現契約開始日',
                    required:true,
                    list:[
                        {name:'secAcpCntrTermSrtDate', type: 'date', pattern:'date',requireCheckItem: true,},
                    ]
                },
                /*契約満了予定日 */
                {
                    id:'row7', 
                    label:'現契約満了予定日',
                    list:[
                        {name:'secAcpCntrTermExpiDate', type: 'date', pattern:'date', startDate:'secAcpCntrTermSrtDate'},
                    ]
                },
                /*出向社員情報 備考 */
                {
                    id:'row8', 
                    label:'出向社員情報 備考', 
                    list:[
                        {name:'secAcpInfoRema', type:'input', maxLength: 255,placeholder:'255文字まで',width:'620px'},
                    ]
                },
                /*管理監督者 */
                {
                    id:'row9', 
                    label:'管理監督者',
                    list:[
                        {name:'mnaSpvrFlag',type:'checkbox'},
                    ]
                },
                
            ];
        /* ====== 出向(受)情報データ編集 ====== */
        /* 出向(受)情報データをコピー　*/
        const acceptedRegisterInformationTableConfigCopy = [...acceptedRegisterInformationTableConfig];
        /* 現契約開始日indexを元にデータを置換 */
        acceptedRegisterInformationTableConfigCopy.splice(secAcpCntrTermSrtDateIndex,1,{
            id:'row6', 
            label:'現契約開始日', 
            list:[
                {name:'secAcpCntrTermSrtDate', type:'dateLabel'}
            ]
        });
        const acceptedUpdateInformationTableConfig = acceptedRegisterInformationTableConfigCopy;


        /* ====== 契約社員データ ====== */
        const contractInformationTableConfig = 
        [    
            /*給与形態 */
            {
                id:'row1', 
                label:'給与形態', 
                list:[
                    {name:'slaFormCd', type:'edit',master:salaryFormCode}
                ]
            },
            /*職種 */
            {
                id:'row2', 
                label:'職種', 
                list:[
                    {name:'ocuCd',   type:'edit',master:occupationCode},
                ]
            },
            /*特記事項 */
            {
                id:'row12', 
                label:'配布方法', 
                list:[
                    {name:'distMerh',   type:'label'},
                ]
            },
            /*担当業務内容 */
            {
                id:'row13', 
                label:'担当業務内容', 
                list:[
                    {name:'cntrBsiContField',   type:'label'},
                ]
            },
            /*差し込み印刷対応 */
            {
                id:'row14', 
                label:'差し込み印刷対応', 
                list:[
                    {name:'mergePrintSprt',   type:'label'},
                ]
            },
            /*契約開始日 */
            {
                id:'row15', 
                label:'契約開始日', 
                list:[
                    {name:'cntrSrtDate',
                    type:'dateLabel',
                },
                ]
            },
            /*最長雇用期間 */
            {
                id:'row16', 
                label:'最長雇用期間', 
                list:[
                    {name:'lngEmpiTerm',   type:'dateLabel'},
                ]
            },
            /*更新間隔 */
            {
                id:'row17', 
                label:'更新間隔', 
                list:[
                    {name:'upIte',   type:'label'},
                ]
            },
            /* 契約期間開始日 */
            {
                id:'row18', 
                label:'契約期間開始日',
                list:[
                        {name:'cntrTermSrtDate',
                        type:'applySelect',
                        applyList: 'contractAppyList',
                    },
                    ]
                },
            /*契約期間満了予定日 */
            {
                id:'row19', 
                label:'契約期間満了予定日', 
                list:[
                    {name:'cntrTermExpiDate',   type:'dateLabel'},
                ]
            },
            /*契約社員情報備考 */
            {
                id:'row20', 
                label:'契約社員情報備考',  
                list:[
                    {name:'cntrInfoRema',   type:'label'},
                ]
            },
            /* 等級 */
            {
                id:'row21', 
                label:'等級',
                list:[
                    {name:'gradeCd', type:'edit', master:groupradeMaster},
                ]
            },
            /* 管理監督者フラグ */
            {
                id:'row22', 
                label:'管理監督者',
                list:[
                    {name:'mnaSpvrFlag',type:'checkbox', disabled: true},
                ],
            },
        ]

        /* ====== 契約情報データ確認 ====== */
        /* 契約期間開始日indexを取得 */
        const contractCntrTermsrtDateIndex = contractInformationTableConfig.findIndex(e=>e.label === '契約期間開始日');
        /* 契約情報データをコピー　*/
        const contractInformationTableConfigCopy = [...contractInformationTableConfig];
        /* 契約期間開始日indexを元にデータを置換 */
        contractInformationTableConfigCopy.splice(contractCntrTermsrtDateIndex,1,{
            id:'row18', 
            label:'契約期間開始日',
            list:[
                {name:'cntrTermSrtDate', type:'dateLabel'}
            ]
        });
        const contractCnfTableConfig = contractInformationTableConfigCopy;

        /* ====== 契約社員データ登録 ====== */
        const contractRegisterInformationTableConfig = 
        [
            /*給与形態 */
            {
                id:'row1', 
                label:'給与形態',
                list:[
                    {name:'slaFormCd', type:'select',master:salaryFormCode}
                ]
            },
            /*職種 */
            {
                id:'row2', 
                label:'職種', 
                list:[
                    {name:'ocuCd', type:'select',master:occupationCode},
                ]
            },
            /*特記事項 */
            {
                id:'row12', 
                label:'配布方法', 
                list:[
                    {name:'distMerh',type:'input',maxLength:255,width:'630px',placeholder:'255文字まで'},
                ]
            },
            /*担当業務内容 */
            {
                id:'row13', 
                label:'担当業務内容', 
                list:[
                    {name:'cntrBsiContField',type:'textarea',maxLength:2048,width:'100%',placeholder:'2048文字まで'},
                ]
            },
            /*差し込み印刷対応 */
            {
                id:'row14', 
                label:'差し込み印刷対応', 
                list:[
                    {name:'mergePrintSprt', type:'input',maxLength:12,placeholder:'12文字まで',},
                ]
            },
            /*契約開始日 */
            {
                id:'row15', 
                label:'契約開始日', 
                list:[
                    {name:'cntrSrtDate', type:'dateLabel'},
                ],
            },
            /*最長雇用期間 */
            {
                id:'row16', 
                label:'最長雇用期間', 
                list:[
                    {name:'lngEmpiTerm', type:'date',pattern:'date'},
                ]
            },
            /*更新間隔 */
            {
                id:'row17', 
                label:'更新間隔', 
                list:[
                    {name:'upIte',type:'input',maxLength:2,pattern:'number',placeholder:'2文字まで',width:'50px'},
                ]
            },
            /*契約期間開始日 */
            {
                id:'row18', 
                label:'契約期間開始日',
                list:[
                    {name:'cntrTermSrtDate',type: 'date', pattern:'date',requireCheckItem: true,},
                ],
                required: true
            },
            /*契約期間満了予定日 */
            {
                id:'row19', 
                label:'契約期間満了予定日', 
                list:[
                    {name:'cntrTermExpiDate', type:'date', startDate:'cntrTermSrtDate', pattern:'date'},
                ]
            },
            /*契約社員情報備考 */
            {
                id:'row20', 
                label:'契約社員情報備考', 
                list:[
                    {name:'cntrInfoRema',type:'input',maxLength:255,width:630,placeholder:'255文字まで',},
                ]
            },
            /* 等級 */
            {
                id:'row21', 
                label:'等級',
                required: true,
                list:[
                    {name:'gradeCd',type:'select',master:groupradeMaster, required: true, onChange:onChangeGradeCd},
                ]
            },
            /* 管理監督者フラグ */
            {
                id:'row22',
                label:'管理監督者',
                list:[
                    {name:'mnaSpvrFlag',type:'checkbox',disabled:disableItem?.mnaSpvrFlag},
                ]
            },
        ];
        /* ====== 契約社員データ編集 ====== */
        /* 契約社員登録データをコピー　*/
        const contractRegisterInformationTableConfigCopy = [...contractRegisterInformationTableConfig];
        /* 契約期間開始日indexを元にデータを置換 */
        contractRegisterInformationTableConfigCopy.splice(contractCntrTermsrtDateIndex,1,{
            id:'row18', 
            label:'契約期間開始日', 
            list:[
                {name:'cntrTermSrtDate', type:'dateLabel'}
            ]
        });
        const contractUpdateInformationTableConfig = contractRegisterInformationTableConfigCopy;
        

        if(mode === 'register' && state === id){//登録モード
            switch(id){
                case'base':
                    result = employeeRegisterTableConfig;
                break;
                case'dpt':
                    result = affiliatedDepartmentTableConfig;
                break;                
                case'expert':
                    result = expertRegisterInformationTableConfig;
                break;
                case'assigned':
                    result = assignedRegisterInformationTableConfig;
                break;
                default:
                    result = '';
                break;
            };
        }else if(mode === 'edit' && state === id){//編集モード
            // const applyList = {
            //     base:'applyList',
            //     expert:'expertApplyList',
            //     temporary:'temporaryApplyList',
            //     assigned:'assignedApplyList',
            //     accepted:'acceptedApplyList',
            //     contract:'contractAppyList'
            // };
            if(dataRow[id].cntrCntFlag === 'false'){
                switch(id){
                    case'temporary':
                        result = temporaryRegisterInformationTableConfig;
                    break;
                    case'assigned':
                        result = assignedRegisterInformationTableConfig;
                    break;
                    case'accepted':
                        result = acceptedRegisterInformationTableConfig;
                    break;
                    case'contract':
                        result = contractRegisterInformationTableConfig;
                    break;
                    default:
                        result = '';
                    break;
                };
            }else{
                switch(id){
                    case'base':
                        result = employeeUpdateTableConfig;
                    break;
                    case'dpt':
                        result = affiliatedDepartmentUpdateTableConfig;
                    break;                    
                    case'expert':
                        result = expertUpdateInformationTableConfig;
                    break;
                    case'temporary':
                        result = temporaryUpdateInformationTableConfig;
                    break;
                    case'assigned':
                        result = assignedUpdateInformationTableConfig;
                    break;
                    case'accepted':
                        result = acceptedUpdateInformationTableConfig;
                    break;
                    case'contract':
                        result = contractUpdateInformationTableConfig;
                    break;
                    default:
                        result = '';
                    break;
                };
            }
            
        }else if(mode === 'updateConfirm' || mode === 'registerConfirm' || mode === 'deleteConfirm'){//確認モード
            switch(id){
                case'base':
                result = employeeCnfTableConfig;
                break;
                case'dpt':
                result = affiliatedDepartmentCnfTableConfig;
                break;                
                case'expert':
                result = expertCnfTableConfig;
                break;
                case'temporary':
                result = tmpCnfTableConfig;
                break;
                case'assigned':
                result = assignedCnfTableConfig;
                break;
                case'accepted':
                result = acceptedCnfTableConfig;
                break;
                case'contract':
                result = contractCnfTableConfig;
                break;
                default:
                    result = employeeCnfTableConfig;
                break;
            };
        }else{//閲覧モード
            switch(id){
                case'base':
                result = employeeInformationTableConfig;
                break;
                case'dpt':
                result = affiliatedDepartmentInformationTableConfig;
                break;                
                case'expert':
                result = expertInformationTableConfig;
                break;
                case'temporary':
                result = tmpInformationTableConfig;
                break;
                case'assigned':
                result = assignedInformationTableConfig;
                break;
                case'accepted':
                result = acceptedInformationTableConfig;
                break;
                case'contract':
                result = contractInformationTableConfig;
                break;
                default:
                    result = employeeInformationTableConfig;
                break;
            };
        };
        return result;
    };

    /*====== テーブルの設定(休務休職、転入、転出)ヘッダー ======*/
    const checkTableArrayHeaderConfig = (id,mode,state) =>{
        let result;
        /* ======== テーブルの設定 ======== */
        /*------ ヘッダの設定 ------*/
        // id       : 項目名
        // rowSpan  : 2~ (縦に結合)
        // colSpan	: 2~ (横に結合)
        // align	: 整列(横方向) Center/inherit/justify/left/right
        // sortTable: true(ソート)
        // fixed	: 位置固定 true
        // left		: 左からの位置	0~
        // right	: 右からの位置 0~
        // width    : セルの幅
        // label1	: 表示名(1段目)
        // label2	: 表示名(2段目)
        // mark     : 入力必須を表す*を表示　true

        /* ====== 転入情報詳細テーブルヘッダー ====== */
        const headDataMoveIn =[
            { id: 'moveInDate', align: 'left', width: '150px',  label1:'転入日',},//転入日
            { id: 'moveInRemaField', align: 'left', width: '400px', label1: '備考'},//備考
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新者
            { id: 'lastUpDate', align: 'left', width: '120px',label1: '最終更新日'},//最終更新日
        ]; 
        /* ====== 転入情報編集テーブルヘッダー ====== */
        const headDataMoveInUpdate =[
            { id: 'deleteIcon', align: 'center', width: '80px',label1: '削除'},//ファンクションボタン
            { id: 'moveInDate', align: 'left', width: '150px',  label1:'転入日',required:true},//転入日
            { id: 'moveInRemaField', align: 'left', width: '400px', label1: '備考'},//備考
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新
            { id: 'lastUpDate', align: 'left', width: '120px', label1: '最終更新日'},//最終更新
        ]; 
        /* ====== 転入情報確認テーブルヘッダー ====== */
        const headDataMoveInCnf =[
            { id: 'moveInDate', align: 'left', width: '150px',  label1:'転入日',},//転入日
            { id: 'moveInRemaField', align: 'left', width: '400px', label1: '備考'},//備考
        ]; 
        /* ====== 転出情報詳細テーブルヘッダー ====== */
        const headDataMoveOut =[
            { id: 'moveOutDate', align: 'left', width: '150px',  label1:'転出日'},//転出日
            { id: 'moveInRemaField', align: 'left', width: '400px',  label1: '備考'},//備考
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新者
            { id: 'lastUpDate', align: 'left', width: '120px',label1: '最終更新日'},//最終更新日
        ]; 
        /* ====== 転出情報編集テーブルヘッダー ====== */
        const headDataMoveOutUpdate =[
            { id: 'deleteIcon', align: 'center', width: '80px',label1: '削除'},//ファンクションボタン
            { id: 'moveOutDate', align: 'left', width: '150px',  label1:'転出日',required:true},//転出日
            { id: 'moveInRemaField', align: 'left', width: '400px',  label1: '備考'},//備考
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新
            { id: 'lastUpDate', align: 'left', width: '120px', label1: '最終更新日'},//最終更新
        ]; 
        /* ====== 転出情報確認テーブルヘッダー ====== */
        const headDataMoveOutCnf =[
            { id: 'moveOutDate', align: 'left', width: '150px',  label1:'転出日'},//転出日
            { id: 'moveInRemaField', align: 'left', width: '350px',  label1: '備考'},//備考
        ]; 
        /* ====== 休務/休暇情報詳細テーブルヘッダー ====== */
        const headDataAbsence =[
            { id: 'absenceTermSrtDate', align: 'left', width: '200px', label1: '休務/休職開始日'},//開始日
            { id: 'absenceTermEndDate', align: 'left', width: '200px',  label1: '休務/休職終了日'},//データ入力日
            { id: 'loaClasfCd', align: 'left', width: '150px',  label1:'区分'},//区分
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新者
            { id: 'lastUpDate', align: 'left', width: '120px',label1: '最終更新日'},//最終更新日
        ]; 
        /* ====== 休務/休暇情報編集テーブルヘッダー ====== */
        const headDataAbsenceUpdate =[
            { id: 'deleteIcon', align: 'center', width: '80px',label1: '削除'},//ファンクションボタン
            { id: 'absenceTermSrtDate', align: 'left', width: '200px', label1: '休務/休職開始日',required:true},//開始日
            { id: 'absenceTermEndDate', align: 'left', width: '200px',  label1: '休務/休職終了日',startDate:'absenceTermSrtDate',required:false},//終了日
            { id: 'loaClasfCd', align: 'left', width: '150px',  label1:'区分',required:true},//区分
            { id: 'lastUdr',align: 'left', width: '120px',  label1: '最終更新者'},//最終更新
            { id: 'lastUpDate', align: 'left', width: '120px', label1: '最終更新日'},//最終更新
        ]; 
        /* ====== 休務/休暇情報確認テーブルヘッダー ====== */
        const headDataAbsenceCnf =[
            { id: 'absenceTermSrtDate', align: 'left', width: '200px', label1: '休務/休職開始日'},//開始日
            { id: 'absenceTermEndDate', align: 'left', width: '200px',  label1: '休務/休職終了日'},//データ入力日
            { id: 'loaClasfCd', align: 'left', width: '150px',  label1:'区分'},//区分
        ]; 
        if(mode === 'edit' && state === id){//編集モード
            switch(id){
                case'movein':
                    result = headDataMoveInUpdate;
                break;
                case'moveout':
                    result = headDataMoveOutUpdate;
                break;
                case'absence':
                    result = headDataAbsenceUpdate;
                break;
                default:
                    result = headDataMoveInUpdate;
                break;
            };
        }else if(mode === 'updateConfirm' || mode === 'registerConfirm'){//確認モード
            switch(id){
                case'movein':
                    result = headDataMoveInCnf;
                break;
                case'moveout':
                    result = headDataMoveOutCnf;
                break;
                case'absence':
                    result = headDataAbsenceCnf;
                break;
                default:
                    result = headDataMoveInCnf;
                break;
            };
        }else{//閲覧モード
            switch(id){
                case'movein':
                    result = headDataMoveIn;
                break;
                case'moveout':
                    result = headDataMoveOut;
                break;
                case'absence':
                    result = headDataAbsence;
                break;
                default:
                    result = headDataMoveIn;
                break;
            };
        }
        return result;
    };

    /*====== テーブルの設定(休務休職、転入、転出)ボディ ======*/
    const checkTableArrayBodyConfig = (id,mode,state) =>{
        let result;
        /*====== BodyCellの設定 ======*/
        // name		    : 項目名
        // name2		: 項目名2 値を２つ受け取りたい場合
        // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
        // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
        // width        : selectの幅調整用
        // color        : 文字の色
        // backgroundColor: 背景の色
        // checkBox     : チェックボックスの名前  *input,checkBox
        // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
        // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
        // func         : 処理 *button,iconButton,select
        // value		: btnFuncで受け取りたい値 *button,iconButton

        /* ====== 休務/休暇情報テーブルデータ ====== */
        const bodyDataAbsence = [
            { name: 'absenceTermSrtDate', type: 'dateLabel', align: 'left'},
            { name: 'absenceTermEndDate', type: 'dateLabel', align: 'left'},
            { name: 'loaClasfCd', type: 'edit',  align: 'left',master:leaveOfAbsenceCode},
            { name: 'lastUdr',type: 'label', align: 'left'},
            { name: 'lastUpDate',type: 'timeLabel', align: 'left'},
        ];
        /* ====== 休務/休暇情報編集テーブルデータ ====== */
        const bodyDataAbsenceUpdate = [
            { name: 'deleteIcon', type: 'deleteIcon', align: 'center'},
            { name: 'absenceTermSrtDate', type: 'date', align: 'left', pattern: 'date',endDate:'absenceTermEndDate',required:true},
            { name: 'absenceTermEndDate', type: 'date', align: 'left', pattern: 'date',startDate:'absenceTermSrtDate',required:false},
            { name: 'loaClasfCd', type: 'select',  align: 'left',master:leaveOfAbsenceCode,required:true},
            { name: 'lastUdr',type: 'label', align: 'left'},
            { name: 'lastUpDate',type: 'timeLabel', align: 'left'},
        ];
        /* ====== 休務/休暇情報確認テーブルデータ ====== */
        const bodyDataAbsenceCnf = [
            { name: 'absenceTermSrtDate', type: 'dateLabel', align: 'left'},
            { name: 'absenceTermEndDate', type: 'dateLabel', align: 'left'},
            { name: 'loaClasfCd', type: 'edit',  align: 'left',master:leaveOfAbsenceCode},
        ];
        /* ====== 転入情報詳細テーブルデータ ====== */
        const bodyDataMoveIn = [
            { name: 'moveInDate', type: 'dateLabel',  align: 'left'},
            { name: 'moveInRemaField', type: 'label', align: 'left'},
            { name: 'lastUdr', type: 'label', align: 'left',},
            { name: 'lastUpDate', type: 'timeLabel', align: 'left',},
        ];
        /* ====== 転入情報編集テーブルデータ ====== */
        const bodyDataMoveInUpdate = [
            { name: 'deleteIcon', type: 'deleteIcon', align: 'center'},
            { name: 'moveInDate', type: 'date',  align: 'left',required:true},
            { name: 'moveInRemaField', type: 'input', align: 'left',maxLength:255},
            { name: 'lastUdr',type: 'label', align: 'left'},
            { name: 'lastUpDate',type: 'timeLabel', align: 'left'},
        ];
        /* ====== 転入情報確認テーブルデータ ====== */
        const bodyDataMoveinCnf = [
            { name: 'moveInDate', type: 'dateLabel',  align: 'left'},
            { name: 'moveInRemaField', type: 'label', align: 'left'},
        ];
        /* ====== 転出情報テーブルデータ ====== */
        const bodyDataMoveOut = [
            { name: 'moveOutDate', type: 'dateLabel',  align: 'left'},
            { name: 'moveOutRemaField', type: 'label', align: 'left'},
            { name: 'lastUdr',  type: 'label', align: 'left'},
            { name: 'lastUpDate', type: 'timeLabel', align: 'left'},
        ];
        /* ====== 転出情報編集テーブルデータ ====== */
        const bodyDataMoveOutUpdate = [
            { name: 'deleteIcon', type: 'deleteIcon', align: 'center'},
            { name: 'moveOutDate', type: 'date',  align: 'left',required:true},
            { name: 'moveOutRemaField', type: 'input', align: 'left',maxLength:255},
            { name: 'lastUdr',type: 'label', align: 'left'},
            { name: 'lastUpDate',type: 'timeLabel', align: 'left'},
        ];
        /* ====== 転出情報確認テーブルデータ ====== */
        const bodyDataMoveoutCnf = [
            { name: 'moveOutDate', type: 'dateLabel',  align: 'left'},
            { name: 'moveOutRemaField', type: 'label', align: 'left'},
        ];

        if(mode === 'edit' && state === id){//編集モード
            switch(id){
                case'movein':
                    result = bodyDataMoveInUpdate;
                break;
                case'moveout':
                    result = bodyDataMoveOutUpdate;
                break;
                case'absence':
                    result = bodyDataAbsenceUpdate;
                break;
                default:
                    result = bodyDataMoveInUpdate;
                break;
            };
        }else if(mode === 'updateConfirm' || mode === 'registerConfirm'){//確認モード
            switch(id){
                case'movein':
                    result = bodyDataMoveinCnf;
                break;
                case'moveout':
                    result = bodyDataMoveoutCnf;
                break;
                case'absence':
                    result = bodyDataAbsenceCnf;
                break;
                default:
                    result = bodyDataMoveinCnf;
                break;
            };
        }else{//閲覧モード
            switch(id){
                case'movein':
                    result = bodyDataMoveIn;
                break;
                case'moveout':
                    result = bodyDataMoveOut;
                break;
                case'absence':
                    result = bodyDataAbsence;
                break;
                default:
                    result = bodyDataMoveIn;
                break;
            };
        }
        return result;
    };

    /*====== underbarの設定 ======*/
    const checkUnderbarType = (type) =>{
        let result;
        switch(type){
            case 'read' :
                result = 'back';
            break;
            case 'registerConfirm' :
                result = 'completeBack';
            break;
            case 'updateConfirm' :
                result = 'completeBack';
            break;
            case 'deleteConfirm' :
                result = 'completeBack';
            break;
            case 'edit' :
                result = 'confirmCancel';
            break;
            case 'register' :
                result = 'confirmCancel';
            break;
            default :
                result = '';
            break;
        };
        return result;
    }

    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */
    /* ====== 画面表示開始前 ====== */
    if(!loading){
        return(
        <></>
        );
    };
    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
            <LoadingProgressBar open={progress}/>
                <EmployeeStyle.SdivWrapper>
                    {/* 画面タイトル */}
                    {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ? 
                        <Title text={titleName()} contents={anchorContents} button={<><ButtonApplydayReturn onClick={onClickNowApply}/><ButtonHistory onClick={onClickHistory}/></>}/>
                        :
                        <Title text={titleName()}/>
                    }
                    {/* 確認文言 */}
					<CommonStyle.GdivConfirmText mode={pageMode}/>
                    <form onSubmit={handleSubmit(onClickSubmit)}>
                        {/* ページコンテンツ */}
                        <div style={{display:'flex',marginTop:'5px'}}>
                                <div style={{flexShrink: 1}}>
                                    <CommonStyle.GdivPageContentsWrapper >
                                        {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ?
                                            <EmployeeStyle.SInformationBlock
                                            id='base'
                                            blockTitle='基本情報'
                                            buttonState={buttonState}
                                            editButtonState={editButtonState}
                                            deleteButtonState={deleteButtonState}
                                            copyButtonState={copyButtonState}
                                            onClickCopy={onClickCopy}
                                            onClickUpdate={onClickUpdate}
                                            onClickDelete={onClickDelete}>
                                            <LeftTitleTable
                                                register={register}
                                                payload='payload'
                                                errors={errors}
                                                dataRow={dataRow.base}
                                                tableConfig={checkTableConfig('base',pageMode,buttonState)}
                                                fieldsArray={fieldsArray}
                                                onChangeApply={onChangeApply}
                                                payloadData={getValues('payload')}
                                                />
                                        </EmployeeStyle.SInformationBlock>
                                        :
                                        buttonState === 'base' ?
                                        <EmployeeStyle.SInformationBlock
                                            id='base'
                                            blockTitle='基本情報'>
                                            <LeftTitleTable
                                                register={register}
                                                payload='payload'
                                                errors={errors}
                                                tableConfig={checkTableConfig('base',pageMode,buttonState)}
                                                fieldsArray={fieldsArray}
                                                onChangeApply={onChangeApply}
                                                payloadData={getValues('payload')}
                                                dataRow={pageMode === 'deleteConfirm' ? dataRow.base: confirm.data}
                                                changeFlags={confirm.flags}
                                                />
                                        </EmployeeStyle.SInformationBlock>
                                        : 
                                        ''
                                        }
                                         {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ?
                                            <EmployeeStyle.SInformationBlock
                                            id='dpt'
                                            blockTitle='所属部署情報'
                                            buttonState={buttonState}
                                            editButtonState={editButtonState}
                                            deleteButtonState={deleteButtonState}
                                            copyButtonState={copyButtonState}
                                            onClickCopy={onClickCopy}
                                            onClickUpdate={onClickUpdate}
                                            onClickDelete={onClickDelete}>
                                            <LeftTitleTable
                                                register={register}
                                                payload='payload'
                                                errors={errors}
                                                dataRow={dataRow.dpt}
                                                tableConfig={checkTableConfig('dpt',pageMode,buttonState)}
                                                fieldsArray={fieldsArray}
                                                onChangeApply={onChangeApply}
                                                payloadData={getValues('payload')}
                                                />
                                        </EmployeeStyle.SInformationBlock>
                                        :
                                        buttonState === 'dpt' ?
                                        <EmployeeStyle.SInformationBlock
                                            id='dpt'
                                            blockTitle='所属部署情報'>
                                            <LeftTitleTable
                                                register={register}
                                                payload='payload'
                                                errors={errors}
                                                tableConfig={checkTableConfig('dpt',pageMode,buttonState)}
                                                fieldsArray={fieldsArray}
                                                onChangeApply={onChangeApply}
                                                payloadData={getValues('payload')}
                                                dataRow={pageMode === 'deleteConfirm' ? dataRow.dpt: confirm.data}
                                                changeFlags={confirm.flags}
                                                />
                                        </EmployeeStyle.SInformationBlock>
                                        : 
                                        ''
                                        }                                       
                                    </CommonStyle.GdivPageContentsWrapper>
                                    
                                    {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ?
                                        fieldList.map((item)=>(
                                            <CommonStyle.GdivPageContentsWrapper key={`${item.id}`}>
                                                <EmployeeStyle.SInformationTable
                                                    id={item.id}
                                                    blockTitle={item.blockTitle}
                                                    buttonState={buttonState}
                                                    editButtonState={editButtonState}
                                                    onClickUpdate={onClickUpdate}>
                                                    <TableArray
                                                        headCells={checkTableArrayHeaderConfig(item.id,pageMode,buttonState)} //ヘッダの設定情報
                                                        bodyCells={checkTableArrayBodyConfig(item.id,pageMode,buttonState)} //ボディの設定情報
                                                        dataRow={dataRow[item.id]} //表示データ
                                                        fieldsList={fieldArrayConfig.field[item.id]}
                                                        append={fieldArrayConfig.append[item.id]}
                                                        remove={fieldArrayConfig.remove[item.id]}
                                                        update={fieldArrayConfig.update[item.id]}
                                                        register={register}
                                                        showBottom={true}
                                                        editMode={buttonState === item.id}
                                                        notShowSearchNumber={true}
                                                        payload='payload'
                                                        payloadCategory={item.id}
                                                        errors={errors}
                                                        payloadData={getValues(`payload.${item.id}`)}
                                                    />    
                                                </EmployeeStyle.SInformationTable>
                                            </CommonStyle.GdivPageContentsWrapper>
                                        ))
                                        :
                                        fieldList.map((item)=>(
                                        item.id === buttonState &&
                                            <CommonStyle.GdivPageContentsWrapper key={`${item.id}`}>
                                                <EmployeeStyle.SInformationTable
                                                key={`confirm${item.id}`}
                                                id={item.id}
                                                blockTitle={item.blockTitle}>
                                                <Table
                                                    headCells={checkTableArrayHeaderConfig(item.id,pageMode,buttonState)} //ヘッダの設定情報
                                                    bodyCells={checkTableArrayBodyConfig(item.id,pageMode,buttonState)} //ボディの設定情報
                                                    dataRow={confirm.data} //表示データ
                                                    // paperStyle={{maxHeight:'calc(20vh)'}} //高さはここ
                                                    notShowSearchNumber={true}
                                                    payloadCategory={item.id}
                                                    changeFlags={confirm.flags}
                                                    // onClickBodyRow={onClickBodyRow}
                                                    // checkState={checkState}
                                                />
                                            </EmployeeStyle.SInformationTable>
                                        </CommonStyle.GdivPageContentsWrapper>
                                        ))
                                    }
                                </div>
                                <div style={{flexShrink: 1, marginLeft:pageMode === 'registerConfirm' || pageMode === 'updateConfirm' || pageMode === 'deleteConfirm' ? '-20px': ''}}>
                                    <CommonStyle.GdivPageContentsWrapper>
                                        {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ?
                                            // エキスパート情報
                                            (getValues('payload.empiSttsCd') === '1' ?

                                                <EmployeeStyle.SInformationBlock
                                                    id='expert'
                                                    blockTitle='エキスパート情報'
                                                    buttonState={buttonState}
                                                    editButtonState={editButtonState}
                                                    deleteButtonState={deleteButtonState}
                                                    copyButtonState={copyButtonState}
                                                    onClickCopy={onClickCopy}
                                                    onClickUpdate={onClickUpdate}
                                                    onClickDelete={onClickDelete}>
                                                    <LeftTitleTable
                                                        register={register}
                                                        payload='payload'
                                                        errors={errors}
                                                        dataRow={dataRow.expert}
                                                        tableConfig={checkTableConfig('expert',pageMode,buttonState)}
                                                        onChangeApply={onChangeApply}
                                                        payloadData={watch('payload')}/>
                                                </EmployeeStyle.SInformationBlock> : '')
                                            :
                                            buttonState === 'expert' ?
                                            <EmployeeStyle.SInformationBlock
                                            id='expert'
                                            blockTitle='エキスパート情報'>
                                                <LeftTitleTable
                                                    register={register}
                                                    payload='payload'
                                                    errors={errors}
                                                    tableConfig={checkTableConfig('expert',pageMode,buttonState)}
                                                    payloadData={getValues('payload')}
                                                    dataRow={pageMode === 'deleteConfirm' ? dataRow.expert: confirm.data}
                                                    changeFlags={confirm.flags}/>
                                            </EmployeeStyle.SInformationBlock>
                                            :
                                            ''
                                        }
                                        {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ?
                                            //派遣社員員情報
                                            (getValues('payload.empiSttsCd') === '2' ? 
                                                <EmployeeStyle.SInformationBlock
                                                    id='temporary'
                                                    blockTitle='派遣社員情報'
                                                    buttonState={buttonState}
                                                    editButtonState={editButtonState}
                                                    onClickUpdate={onClickUpdate}
                                                    onClickDelete={onClickDelete}>
                                                    <LeftTitleTable
                                                        register={register}
                                                        payload='payload'
                                                        errors={errors}
                                                        dataRow={dataRow.temporary}
                                                        tableConfig={checkTableConfig('temporary',pageMode,buttonState)}
                                                        onChangeApply={onChangeApply}
                                                        payloadData={watch('payload')}/>
                                                    </EmployeeStyle.SInformationBlock>:'')
                                            :
                                            buttonState === 'temporary' ?
                                            <EmployeeStyle.SInformationBlock
                                            id='base'
                                            blockTitle='派遣社員情報'>
                                            <LeftTitleTable
                                                register={register}
                                                payload='payload'
                                                errors={errors}
                                                tableConfig={checkTableConfig('temporary',pageMode,buttonState)}
                                                dataRow={confirm.data}
                                                changeFlags={confirm.flags}
                                                />
                                            </EmployeeStyle.SInformationBlock>
                                            :''
                                        }

                                       {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ?
                                        //出向(出)情報
                                        (getValues('payload.dptCd')?.indexOf('Z') !== -1 ? 
                                            <EmployeeStyle.SInformationBlock
                                                id='assigned'
                                                blockTitle='出向(出)情報'
                                                buttonState={buttonState}
                                                editButtonState={editButtonState}
                                                deleteButtonState={deleteButtonState}
                                                onClickUpdate={onClickUpdate}
                                                onClickDelete={onClickDelete} 
                                                onClickRegister={copyButtonState.assigned && onClickRegist}>
                                                    <LeftTitleTable
                                                        register={register}
                                                        payload='payload'
                                                        errors={errors}
                                                        dataRow={dataRow.assigned}
                                                        tableConfig={checkTableConfig('assigned',pageMode,buttonState)}
                                                        onChangeApply={onChangeApply}
                                                        payloadData={watch('payload')}/>
                                            </EmployeeStyle.SInformationBlock> : '')
                                        :buttonState === 'assigned' ?
                                        <EmployeeStyle.SInformationBlock
                                        id='assigned'
                                        blockTitle='出向(出)情報'>
                                        <LeftTitleTable
                                            register={register}
                                            payload='payload'
                                            errors={errors}
                                            tableConfig={checkTableConfig('assigned',pageMode,buttonState)}
                                            dataRow={pageMode === 'deleteConfirm' ? dataRow.assigned: confirm.data}
                                            changeFlags={confirm.flags}
                                            />
                                        </EmployeeStyle.SInformationBlock>
                                        :''
                                        }
                                        {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ?
                                        //出向(受)情報 
                                        (getValues('payload.empiSttsCd') === '4' ?
                                            <EmployeeStyle.SInformationBlock
                                            id='accepted'
                                            blockTitle='出向(受)情報'
                                            buttonState={buttonState}
                                            editButtonState={editButtonState}
                                            onClickUpdate={onClickUpdate}
                                            onClickDelete={onClickDelete}>
                                                <LeftTitleTable
                                                    register={register}
                                                    payload='payload'
                                                    errors={errors}
                                                    dataRow={dataRow.accepted}
                                                    tableConfig={checkTableConfig('accepted',pageMode,buttonState)}
                                                    onChangeApply={onChangeApply}
                                                    payloadData={watch('payload')}/>
                                            </EmployeeStyle.SInformationBlock>:'')
                                        :buttonState === 'accepted' ?
                                        <EmployeeStyle.SInformationBlock
                                        id='accepted'
                                        blockTitle='出向(受)情報'>
                                        <LeftTitleTable
                                            register={register}
                                            payload='payload'
                                            errors={errors}
                                            tableConfig={checkTableConfig('accepted',pageMode,buttonState)}
                                            dataRow={confirm.data}
                                            changeFlags={confirm.flags}
                                            />
                                        </EmployeeStyle.SInformationBlock>
                                        :''
                                        }
                                        {pageMode === 'read' || pageMode === 'edit' || pageMode === 'register' ?
                                        //契約社員情報
                                        (getValues('payload.empiSttsCd') === '3' ?
                                            <EmployeeStyle.SInformationBlock
                                                id='contract'
                                                blockTitle='契約社員情報'
                                                buttonState={buttonState}
                                                editButtonState={editButtonState}
                                                onClickUpdate={onClickUpdate}
                                                onClickDelete={onClickDelete}>
                                                    <LeftTitleTable
                                                        register={register}
                                                        payload='payload'
                                                        errors={errors}
                                                        dataRow={dataRow.contract}
                                                        tableConfig={checkTableConfig('contract',pageMode,buttonState)}
                                                        onChangeApply={onChangeApply}
                                                        payloadData={watch('payload')}/>
                                            </EmployeeStyle.SInformationBlock>:'')
                                        :buttonState === 'contract' ?
                                        <EmployeeStyle.SInformationBlock
                                        id='contract'
                                        blockTitle='契約社員情報'
                                        onClickUpdate={onClickUpdate}
                                        onClickDelete={onClickDelete}>
                                        <LeftTitleTable
                                            register={register}
                                            payload='payload'
                                            errors={errors}
                                            tableConfig={checkTableConfig('contract',pageMode,buttonState)}
                                            dataRow={confirm.data}
                                            changeFlags={confirm.flags}
                                            />
                                        </EmployeeStyle.SInformationBlock>
                                        :''
                                        }
                                    </CommonStyle.GdivPageContentsWrapper>
                                </div>
                            </div>
                        
                        {/* アンダーバー */}
                        <Underbar
                        type={checkUnderbarType(pageMode)}
                        onClickLeft={onClickLeft}
                        onClickCenter={pageMode === 'deleteConfirm' ? deleteData : updateData}
                        
                        />
                </form>
                </EmployeeStyle.SdivWrapper>
            {/* ダイアログ */}
            <Dialog
				content={dialogMessage}
				set={setDialogMessage}
			/> 
            {/* スナックバー */}
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}/>
        </>
    )
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */